// Generated by scripts/gen-dd-icons.py (tasks#211) - regenerate, do not hand-edit.
// DoorDash icons (and their ordit-uk-web2 copies) rendered by src/plugins/ddIcons.js in place
// of the Material icons named in DD_ICON_ALIASES.
export const DD_ICONS = {
    plus: {
        viewBox: '0 0 16 16',
        paths: [
            {
                d:
                    'M7 14V9H2C1.44772 9 1 8.55228 1 8C1 7.44772 1.44772 7 2 7H7V2C7 1.44772 7.44772 1 8 1C8.55228 1 9 1.44772 9 2V7H14C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9H9V14C9 14.5523 8.55228 15 8 15C7.44772 15 7 14.5523 7 14Z',
                evenodd: false,
            },
        ],
    },
    'plus-circle': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12ZM10.999 15.999V12.999H7.99902C7.44685 12.9989 6.99902 12.5512 6.99902 11.999C6.99916 11.4469 7.44693 10.9992 7.99902 10.999H10.999V7.99902C10.9992 7.44693 11.4469 6.99916 11.999 6.99902C12.5512 6.99902 12.9989 7.44685 12.999 7.99902V10.999H15.999C16.5512 10.999 16.9989 11.4469 16.999 11.999C16.999 12.5513 16.5513 12.999 15.999 12.999H12.999V15.999C12.999 16.5513 12.5513 16.999 11.999 16.999C11.4469 16.9989 10.999 16.5512 10.999 15.999ZM23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z',
                evenodd: false,
            },
        ],
    },
    close: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M18.7929 3.79302C19.1834 3.40249 19.8164 3.40249 20.207 3.79302C20.5974 4.18355 20.5975 4.81658 20.207 5.20708L13.414 12L20.207 18.793C20.5974 19.1835 20.5975 19.8166 20.207 20.2071C19.8165 20.5976 19.1834 20.5975 18.7929 20.2071L11.9999 13.4141L5.20696 20.2071C4.81646 20.5976 4.18342 20.5975 3.79289 20.2071C3.40237 19.8166 3.40237 19.1835 3.79289 18.793L10.5859 12L3.79289 5.20708C3.40237 4.81655 3.40237 4.18354 3.79289 3.79302C4.18342 3.40249 4.81643 3.40249 5.20696 3.79302L11.9999 10.586L18.7929 3.79302Z',
                evenodd: false,
            },
        ],
    },
    'circle-x': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16.2071 7.79289C16.5976 8.18342 16.5976 8.81658 16.2071 9.20711L13.4142 12L16.2071 14.7929C16.5976 15.1834 16.5976 15.8166 16.2071 16.2071C15.8166 16.5976 15.1834 16.5976 14.7929 16.2071L12 13.4142L9.20711 16.2071C8.81658 16.5976 8.18342 16.5976 7.79289 16.2071C7.40237 15.8166 7.40237 15.1834 7.79289 14.7929L10.5858 12L7.79289 9.2071C7.40237 8.81658 7.40237 8.18341 7.79289 7.79289C8.18341 7.40237 8.81658 7.40237 9.2071 7.79289L12 10.5858L14.7929 7.79289C15.1834 7.40237 15.8166 7.40237 16.2071 7.79289Z',
                evenodd: true,
            },
        ],
    },
    trash: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M14.2041 1.01074C15.2128 1.113 16 1.96435 16 3V5H21L21.1025 5.00488C21.6067 5.05621 22 5.48232 22 6C22 6.51768 21.6067 6.94379 21.1025 6.99512L21 7H20V19C20 21.2091 18.2091 23 16 23H8C5.79086 23 4 21.2091 4 19V7H3C2.44772 7 2 6.55228 2 6C2 5.44772 2.44772 5 3 5H8V3C8 1.89543 8.89543 1 10 1H14L14.2041 1.01074ZM6 19C6 20.1046 6.89543 21 8 21H16C17.1046 21 18 20.1046 18 19V7H6V19ZM10 5H14V3H10V5Z',
                evenodd: true,
            },
        ],
    },
    copy: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M1 19V7C1 6.44772 1.44772 6 2 6C2.55228 6 3 6.44772 3 7V19C3 20.1046 3.89543 21 5 21H17C17.5523 21 18 21.4477 18 22C18 22.5523 17.5523 23 17 23H5C2.79086 23 1 21.2091 1 19ZM21 5C21 3.89543 20.1046 3 19 3H9C7.89543 3 7 3.89543 7 5V15C7 16.1046 7.89543 17 9 17H19C20.1046 17 21 16.1046 21 15V5ZM23 15C23 17.2091 21.2091 19 19 19H9C6.79086 19 5 17.2091 5 15V5C5 2.79086 6.79086 1 9 1H19C21.2091 1 23 2.79086 23 5V15Z',
                evenodd: true,
            },
        ],
    },
    'copy-16': {
        viewBox: '0 0 16 16',
        paths: [
            {
                d:
                    'M-6.10352e-05 12.9999V4.99988C-6.10352e-05 4.44759 0.447654 3.99988 0.999939 3.99988C1.55222 3.99988 1.99994 4.44759 1.99994 4.99988V12.9999C1.99994 13.5522 2.44765 13.9999 2.99994 13.9999H10.9999C11.5522 13.9999 11.9999 14.4476 11.9999 14.9999C11.9999 15.5522 11.5522 15.9999 10.9999 15.9999H2.99994C1.34308 15.9999 -6.10352e-05 14.6567 -6.10352e-05 12.9999ZM13.9999 2.99988C13.9999 2.44759 13.5522 1.99988 12.9999 1.99988H5.99994C5.44765 1.99988 4.99994 2.44759 4.99994 2.99988V9.99988C4.99994 10.5522 5.44765 10.9999 5.99994 10.9999H12.9999C13.5522 10.9999 13.9999 10.5522 13.9999 9.99988V2.99988ZM15.9999 9.99988C15.9999 11.6567 14.6568 12.9999 12.9999 12.9999H5.99994C4.34308 12.9999 2.99994 11.6567 2.99994 9.99988V2.99988C2.99994 1.34302 4.34308 -0.00012207 5.99994 -0.00012207H12.9999C14.6568 -0.00012207 15.9999 1.34302 15.9999 2.99988V9.99988Z',
                evenodd: true,
            },
        ],
    },
    print: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M22 11C22 9.13616 20.7252 7.57006 19 7.12602V5C19 3.34315 17.6569 2 16 2H8C6.34315 2 5 3.34315 5 5V7.12602C3.27477 7.57006 2 9.13616 2 11V16C2 17.1046 2.89543 18 4 18H5V19C5 20.6569 6.34315 22 8 22H16C17.6569 22 19 20.6569 19 19V18H20C21.1046 18 22 17.1046 22 16V11ZM17 5V7H7V5C7 4.44772 7.44772 4 8 4H16C16.5523 4 17 4.44772 17 5ZM16 20C16.5523 20 17 19.5523 17 19V12H7V19C7 19.5523 7.44772 20 8 20H16Z',
                evenodd: true,
            },
            {
                d:
                    'M8 18C8 17.4477 8.44772 17 9 17H11C11.5523 17 12 17.4477 12 18C12 18.5523 11.5523 19 11 19H9C8.44772 19 8 18.5523 8 18Z',
                evenodd: false,
            },
            {
                d:
                    'M8 15C8 14.4477 8.44772 14 9 14H13C13.5523 14 14 14.4477 14 15C14 15.5523 13.5523 16 13 16H9C8.44772 16 8 15.5523 8 15Z',
                evenodd: false,
            },
        ],
    },
    'more-vertical': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M14.0002 4C14.0002 5.10457 13.1048 6 12.0002 6C10.8957 6 10.0002 5.10457 10.0002 4C10.0002 2.89543 10.8957 2 12.0002 2C13.1048 2 14.0002 2.89543 14.0002 4Z',
                evenodd: false,
            },
            {
                d:
                    'M13.9999 12C13.9999 13.1046 13.1044 14 11.9999 14C10.8953 14 9.99988 13.1046 9.99988 12C9.99988 10.8954 10.8953 10 11.9999 10C13.1044 10 13.9999 10.8954 13.9999 12Z',
                evenodd: false,
            },
            {
                d:
                    'M14.0002 20C14.0002 21.1046 13.1048 22 12.0002 22C10.8957 22 10.0002 21.1046 10.0002 20C10.0002 18.8954 10.8957 18 12.0002 18C13.1048 18 14.0002 18.8954 14.0002 20Z',
                evenodd: false,
            },
        ],
    },
    'more-horizontal': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M6 12C6 13.1046 5.10457 14 4 14C2.89543 14 2 13.1046 2 12C2 10.8954 2.89543 10 4 10C5.10457 10 6 10.8954 6 12Z',
                evenodd: false,
            },
            {
                d:
                    'M13.9993 12C13.9993 13.1046 13.1039 14 11.9993 14C10.8948 14 9.99935 13.1046 9.99935 12C9.99935 10.8954 10.8948 10 11.9993 10C13.1039 10 13.9993 10.8954 13.9993 12Z',
                evenodd: false,
            },
            {
                d:
                    'M22 12C22 13.1046 21.1046 14 20 14C18.8954 14 18 13.1046 18 12C18 10.8954 18.8954 10 20 10C21.1046 10 22 10.8954 22 12Z',
                evenodd: false,
            },
        ],
    },
    'fork-spoon': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M10 0.99939C10.5523 0.99939 11 1.4471 11 1.99939V8.99939C11 11.4183 9.28219 13.4355 7 13.8988V21.9994C7 22.5517 6.55228 22.9994 6 22.9994C5.44772 22.9994 5 22.5517 5 21.9994V13.8988C2.71781 13.4355 1 11.4183 1 8.99939V1.99939C1 1.4471 1.44772 0.99939 2 0.99939C2.55228 0.99939 3 1.4471 3 1.99939V5.99939H5V1.99939C5 1.4471 5.44772 0.99939 6 0.99939C6.55228 0.99939 7 1.4471 7 1.99939V5.99939H9V1.99939C9 1.4471 9.44771 0.99939 10 0.99939ZM3 8.99939C3 10.6562 4.34315 11.9994 6 11.9994C7.65685 11.9994 9 10.6562 9 8.99939V7.99939H3V8.99939Z',
                evenodd: true,
            },
            {
                d:
                    'M18 0.99939C19.5032 0.99939 20.7764 1.83914 21.6367 3.02185C22.4977 4.20574 23 5.79221 23 7.49939C23 9.20657 22.4977 10.793 21.6367 11.9769C20.9747 12.887 20.0676 13.5919 19 13.8695V21.9994C19 22.5517 18.5523 22.9994 18 22.9994C17.4477 22.9994 17 22.5517 17 21.9994V13.8695C15.9324 13.5919 15.0253 12.887 14.3633 11.9769C13.5023 10.793 13 9.20657 13 7.49939C13 5.79221 13.5023 4.20574 14.3633 3.02185C15.2236 1.83914 16.4968 0.99939 18 0.99939ZM18 2.99939C17.2942 2.99939 16.5679 3.39091 15.9805 4.19861C15.3938 5.00532 15 6.16901 15 7.49939C15 8.82977 15.3938 9.99345 15.9805 10.8002C16.5679 11.6079 17.2942 11.9994 18 11.9994C18.7058 11.9994 19.4321 11.6079 20.0195 10.8002C20.6062 9.99345 21 8.82977 21 7.49939C21 6.16901 20.6062 5.00532 20.0195 4.19861C19.4321 3.39091 18.7058 2.99939 18 2.99939Z',
                evenodd: true,
            },
        ],
    },
    download: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M21 20C21.5522 20 21.9999 20.4478 22 21C22 21.5523 21.5523 22 21 22H3C2.44772 22 2 21.5523 2 21C2.00012 20.4478 2.44779 20 3 20H21ZM11 2C11 1.44772 11.4477 1 12 1C12.5521 1.00017 13 1.44782 13 2V14.5859L17.293 10.293C17.6835 9.90244 18.3165 9.90244 18.707 10.293C19.0976 10.6835 19.0976 11.3165 18.707 11.707L13.4141 17C12.633 17.7809 11.367 17.7809 10.5859 17L5.29297 11.707C4.90244 11.3165 4.90244 10.6835 5.29297 10.293C5.68349 9.90244 6.31651 9.90244 6.70703 10.293L11 14.5859V2Z',
                evenodd: false,
            },
        ],
    },
    upload: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M2 17.9957V13.9957C2.00012 13.4436 2.44779 12.9957 3 12.9957C3.55221 12.9957 3.99988 13.4436 4 13.9957V17.9957C4 19.1003 4.89543 19.9957 6 19.9957H18C19.1046 19.9957 20 19.1003 20 17.9957V13.9957C20.0001 13.4436 20.4478 12.9957 21 12.9957C21.5522 12.9957 21.9999 13.4436 22 13.9957V17.9957C22 20.2049 20.2091 21.9957 18 21.9957H6C3.79086 21.9957 2 20.2049 2 17.9957ZM11 15.9957V4.40981L6.70703 8.70278C6.31651 9.09328 5.68349 9.09329 5.29297 8.70278C4.90247 8.31226 4.90247 7.67923 5.29297 7.28871L10.5859 1.99575C11.367 1.21478 12.633 1.21481 13.4141 1.99575L18.707 7.28871C19.0976 7.67924 19.0976 8.31225 18.707 8.70278C18.3165 9.09328 17.6835 9.09329 17.293 8.70278L13 4.40981V15.9957C13 16.5479 12.5521 16.9956 12 16.9957C11.4477 16.9957 11 16.548 11 15.9957Z',
                evenodd: false,
            },
        ],
    },
    clipboard: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M13 12C13.3788 12 13.7251 12.214 13.8945 12.5527L15.6182 16H16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18H15C14.6212 18 14.2749 17.786 14.1055 17.4473L13 15.2363L11.8945 17.4473C11.7508 17.7348 11.4774 17.9358 11.1602 17.9873C10.8429 18.0388 10.5202 17.9343 10.293 17.707L9.5 16.9141L8.70703 17.707C8.31651 18.0976 7.68349 18.0976 7.29297 17.707C6.90244 17.3165 6.90244 16.6835 7.29297 16.293L8.79297 14.793C9.18349 14.4024 9.81651 14.4024 10.207 14.793L10.7256 15.3115L12.1055 12.5527C12.2749 12.214 12.6212 12 13 12Z',
                evenodd: false,
            },
            {
                d:
                    'M12 1C13.482 1 14.7686 1.80697 15.459 3H18C20.2091 3 22 4.79086 22 7V19L21.9951 19.2061C21.8879 21.3194 20.14 23 18 23H6C3.85996 23 2.11211 21.3194 2.00488 19.2061L2 19V7C2 4.79086 3.79086 3 6 3H8.54102C9.23137 1.80697 10.518 1 12 1ZM6 5C4.89543 5 4 5.89543 4 7V19L4.01074 19.2041C4.113 20.2128 4.96435 21 6 21H18L18.2041 20.9893C19.1457 20.8938 19.8938 20.1457 19.9893 19.2041L20 19V7C20 5.96435 19.2128 5.11301 18.2041 5.01074L18 5V7C18 8.10457 17.1046 9 16 9H8C6.89543 9 6 8.10457 6 7V5ZM12 3C11.1326 3 10.392 3.55463 10.1162 4.33398L9.88086 5H8V7H16V5H14.1191L13.8838 4.33398C13.608 3.55463 12.8674 3 12 3Z',
                evenodd: true,
            },
        ],
    },
    'clipboard-list': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M7.02236 3.69995C7.00763 3.79782 7 3.89802 7 4V5.5C7 5.56748 7.00334 5.63419 7.00987 5.69995H7C6.44772 5.69995 6 6.14767 6 6.69995V19C6 19.5522 6.44772 20 7 20H17C17.5523 20 18 19.5522 18 18.9999V6.69995C18 6.14767 17.5523 5.69995 17 5.69995H16.9901C16.9967 5.63419 17 5.56748 17 5.5V4C17 3.89802 16.9924 3.79782 16.9776 3.69995H17C18.6569 3.69995 20 5.0431 20 6.69995V18.9999C20 20.6568 18.6569 22 17 22H7C5.34315 22 4 20.6568 4 19V6.69995C4 5.0431 5.34315 3.69995 7 3.69995H7.02236Z',
                evenodd: false,
            },
            {
                d:
                    'M15 4H9V5.5H15V4ZM9 2C7.89543 2 7 2.89543 7 4V5.5C7 6.60457 7.89543 7.5 9 7.5H15C16.1046 7.5 17 6.60457 17 5.5V4C17 2.89543 16.1046 2 15 2H9Z',
                evenodd: true,
            },
            {
                d:
                    'M8 11C8 10.4478 8.44772 10 9 10H15C15.5523 10 16 10.4478 16 11C16 11.5523 15.5523 12 15 12H9C8.44772 12 8 11.5523 8 11Z',
                evenodd: false,
            },
            {
                d:
                    'M8 15C8 14.4478 8.44772 14 9 14H13C13.5523 14 14 14.4478 14 15C14 15.5523 13.5523 16 13 16H9C8.44772 16 8 15.5523 8 15Z',
                evenodd: false,
            },
        ],
    },
    pencil: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M15.293 3.29121C16.788 1.79632 19.212 1.79632 20.707 3.29121C22.2021 4.78626 22.202 7.21017 20.707 8.70528L7 22.4123C6.62496 22.7873 6.11631 22.9982 5.58594 22.9982H3C1.89543 22.9982 1 22.1028 1 20.9982V18.4123C1.00012 17.882 1.21097 17.3732 1.58594 16.9982L15.293 3.29121ZM19.293 4.70528C18.579 3.99143 17.421 3.99143 16.707 4.70528L15.4141 5.99824L18 8.58418L19.293 7.29121C20.0069 6.57716 20.007 5.41927 19.293 4.70528ZM3 20.9982H5.58594L16.5859 9.99824L14 7.41231L3 18.4123V20.9982Z',
                evenodd: false,
            },
        ],
    },
    document: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M3 21V3C3 1.89543 3.89543 1 5 1H13.7578C13.811 1.00001 13.864 1.00277 13.917 1.00488C13.9444 1.00263 13.972 1 14 1C14.0833 1 14.1638 1.01204 14.2412 1.03125C15.1237 1.13882 15.9508 1.53674 16.5859 2.17188L19.8281 5.41406C20.463 6.04897 20.861 6.87569 20.9688 7.75781C20.9881 7.83548 21 7.91634 21 8C21 8.02766 20.9973 8.05494 20.9951 8.08203C20.9973 8.13531 21 8.18866 21 8.24219V21C21 22.1046 20.1046 23 19 23H5C3.89543 23 3 22.1046 3 21ZM16 16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18H8C7.44772 18 7 17.5523 7 17C7 16.4477 7.44772 16 8 16H16ZM16 12C16.5523 12 17 12.4477 17 13C17 13.5523 16.5523 14 16 14H8C7.44772 14 7 13.5523 7 13C7 12.4477 7.44772 12 8 12H16ZM18.5654 7C18.5182 6.94052 18.4683 6.88236 18.4141 6.82812L15.1719 3.58594C15.1176 3.5317 15.0595 3.48179 15 3.43457V7H18.5654ZM5 21H19V9H15C13.8954 9 13 8.10457 13 7V3H5V21Z',
                evenodd: false,
            },
        ],
    },
    'chevron-right': {
        viewBox: '0 0 16 16',
        paths: [
            {
                d:
                    'M5.79289 2.79289C6.18342 2.40237 6.81643 2.40237 7.20696 2.79289L11.707 7.29289C12.0975 7.68342 12.0975 8.31643 11.707 8.70696L7.20696 13.207C6.81643 13.5974 6.18341 13.5975 5.79289 13.207C5.40242 12.8164 5.40242 12.1834 5.79289 11.7929L9.58586 7.99992L5.79289 4.20696C5.40237 3.81643 5.40237 3.18342 5.79289 2.79289Z',
                evenodd: true,
            },
        ],
    },
    'chevron-left': {
        viewBox: '0 0 16 16',
        paths: [
            {
                d:
                    'M8.79288 2.79288C9.18341 2.40238 9.81643 2.40237 10.2069 2.79288C10.5974 3.1834 10.5974 3.81643 10.2069 4.20695L6.41398 7.99991L10.2069 11.7929C10.5975 12.1834 10.5975 12.8164 10.2069 13.2069C9.81642 13.5975 9.1834 13.5975 8.79288 13.2069L4.29288 8.70695C3.90237 8.31643 3.90238 7.68341 4.29288 7.29288L8.79288 2.79288Z',
                evenodd: true,
            },
        ],
    },
    'chevron-down': {
        viewBox: '0 0 16 16',
        paths: [
            {
                d:
                    'M11.793 5.79289C12.1835 5.40237 12.8165 5.40237 13.2071 5.79289C13.5976 6.18342 13.5976 6.81643 13.2071 7.20696L8.70706 11.707C8.31653 12.0975 7.68352 12.0975 7.293 11.707L2.793 7.20696C2.40251 6.81643 2.40248 6.18341 2.793 5.79289C3.18351 5.40242 3.81654 5.40242 4.20706 5.79289L8.00003 9.58586L11.793 5.79289Z',
                evenodd: true,
            },
        ],
    },
    'chevron-up': {
        viewBox: '0 0 16 16',
        paths: [
            {
                d:
                    'M11.793 10.2071C12.1835 10.5976 12.8165 10.5976 13.2071 10.2071C13.5976 9.81658 13.5976 9.18357 13.2071 8.79304L8.70706 4.293C8.31653 3.9025 7.68352 3.9025 7.293 4.293L2.793 8.79304C2.40251 9.18357 2.40248 9.81659 2.793 10.2071C3.18351 10.5976 3.81654 10.5976 4.20706 10.2071L8.00003 6.41414L11.793 10.2071Z',
                evenodd: true,
            },
        ],
    },
    'arrow-left': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M9.78876 3.79298C10.1793 3.40253 10.8123 3.40248 11.2028 3.79298C11.5932 4.18348 11.5932 4.81653 11.2028 5.20704L5.40985 11H20.9958C21.548 11.0001 21.9958 11.4478 21.9958 12C21.9958 12.5522 21.548 12.9999 20.9958 13H5.40985L11.2028 18.793C11.5932 19.1835 11.5932 19.8165 11.2028 20.207C10.8123 20.5975 10.1793 20.5975 9.78876 20.207L2.99579 13.4141C2.21474 12.633 2.21474 11.367 2.99579 10.5859L9.78876 3.79298Z',
                evenodd: false,
            },
        ],
    },
    'arrow-right': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M12.793 3.79295C13.1835 3.40243 13.8165 3.40243 14.207 3.79295L21 10.5859C21.7809 11.367 21.7809 12.633 21 13.414L14.207 20.207C13.8165 20.5975 13.1835 20.5975 12.793 20.207C12.4024 19.8165 12.4024 19.1835 12.793 18.793L18.5859 13H3C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11H18.5859L12.793 5.20702C12.4024 4.81649 12.4024 4.18348 12.793 3.79295Z',
                evenodd: false,
            },
        ],
    },
    'arrow-up': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M9.78876 3.79298C10.1793 3.40253 10.8123 3.40248 11.2028 3.79298C11.5932 4.18348 11.5932 4.81653 11.2028 5.20704L5.40985 11H20.9958C21.548 11.0001 21.9958 11.4478 21.9958 12C21.9958 12.5522 21.548 12.9999 20.9958 13H5.40985L11.2028 18.793C11.5932 19.1835 11.5932 19.8165 11.2028 20.207C10.8123 20.5975 10.1793 20.5975 9.78876 20.207L2.99579 13.4141C2.21474 12.633 2.21474 11.367 2.99579 10.5859L9.78876 3.79298Z',
                evenodd: false,
            },
        ],
        rotate: 90,
    },
    'arrow-down': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M9.78876 3.79298C10.1793 3.40253 10.8123 3.40248 11.2028 3.79298C11.5932 4.18348 11.5932 4.81653 11.2028 5.20704L5.40985 11H20.9958C21.548 11.0001 21.9958 11.4478 21.9958 12C21.9958 12.5522 21.548 12.9999 20.9958 13H5.40985L11.2028 18.793C11.5932 19.1835 11.5932 19.8165 11.2028 20.207C10.8123 20.5975 10.1793 20.5975 9.78876 20.207L2.99579 13.4141C2.21474 12.633 2.21474 11.367 2.99579 10.5859L9.78876 3.79298Z',
                evenodd: false,
            },
        ],
        rotate: -90,
    },
    minus: {
        viewBox: '0 0 16 16',
        paths: [
            {
                d:
                    'M14 7C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9L2 9C1.44772 9 1 8.55229 1 8C1 7.44772 1.44772 7 2 7L14 7Z',
                evenodd: false,
            },
        ],
    },
    'minus-circle': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12ZM23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z',
                evenodd: false,
            },
            {
                d:
                    'M15.9993 10.9993C16.5516 10.9993 16.9993 11.447 16.9993 11.9993C16.9993 12.5516 16.5516 12.9993 15.9993 12.9993L7.99927 12.9993C7.44698 12.9993 6.99927 12.5516 6.99927 11.9993C6.99927 11.447 7.44698 10.9993 7.99927 10.9993L15.9993 10.9993Z',
                evenodd: false,
            },
        ],
    },
    check: {
        viewBox: '0 0 16 16',
        paths: [
            {
                d:
                    'M13.3704 3.27958C13.7432 2.90681 14.3476 2.90681 14.7204 3.27958C15.0932 3.65235 15.0932 4.2568 14.7204 4.62957L6.12948 13.2205C5.95048 13.3995 5.70762 13.5 5.45449 13.5C5.20134 13.4999 4.95849 13.3995 4.77949 13.2205L1.27955 9.72057C0.906798 9.34781 0.906833 8.74335 1.27955 8.37058C1.65233 7.99781 2.25677 7.99781 2.62954 8.37058L5.45449 11.1955L13.3704 3.27958Z',
                evenodd: false,
            },
        ],
    },
    'check-circle': {
        viewBox: '0 0 16 16',
        paths: [
            {
                d:
                    'M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM11.332 5.15918C11.006 4.89343 10.5256 4.94268 10.2598 5.26855L7.12598 9.1123L5.69043 7.66797C5.39401 7.36964 4.91175 7.36784 4.61328 7.66406C4.31492 7.96056 4.3139 8.44277 4.61035 8.74121L6.6416 10.7871C6.79374 10.9401 7.00421 11.0213 7.21973 11.0107C7.43506 11 7.63618 10.8985 7.77246 10.7314L11.4404 6.23145C11.7059 5.90546 11.6578 5.42498 11.332 5.15918Z',
                evenodd: true,
            },
        ],
    },
    'location-pin': {
        viewBox: '0 0 16 16',
        paths: [
            {
                d:
                    'M8 4C9.10457 4 10 4.89543 10 6C10 7.10457 9.10457 8 8 8C6.89543 8 6 7.10457 6 6C6 4.89543 6.89543 4 8 4Z',
                evenodd: false,
            },
            {
                d:
                    'M8 0C11.3137 0 14 2.68629 14 6C14 9.02643 12.2284 11.9593 9.07422 14.7949C8.46347 15.344 7.53652 15.344 6.92578 14.7949C3.77163 11.9593 2 9.02643 2 6C2 2.72489 4.68186 0 8 0ZM8 2C5.79529 2 4 3.82057 4 6C4 8.13541 5.21679 10.4869 8 13.0635C10.7832 10.4869 12 8.13541 12 6C12 3.79086 10.2091 2 8 2Z',
                evenodd: true,
            },
        ],
    },
    'map-pin': {
        viewBox: '-2 0 16 16',
        paths: [
            {
                d:
                    'M6 16C6.57128 16 7.11528 15.7557 7.49482 15.3287L7.49749 15.3257L7.50163 15.321L7.51421 15.3068L7.55592 15.2589C7.59084 15.2187 7.63972 15.1618 7.70056 15.0897C7.82213 14.9455 7.9921 14.7399 8.1944 14.4838C8.5973 13.9738 9.1368 13.2533 9.6798 12.4129C10.6943 10.8429 12 8.44131 12 6.11932C12 2.79553 9.3687 0 6 0C2.63128 0 0 2.79553 0 6.11932C0 8.44131 1.30574 10.8429 2.32018 12.4129C2.86322 13.2533 3.40275 13.9738 3.80562 14.4838C4.0079 14.7399 4.17787 14.9455 4.29944 15.0897C4.36028 15.1618 4.40916 15.2187 4.44408 15.2589L4.48579 15.3068L4.49837 15.321L4.50251 15.3257L4.50518 15.3287C4.88472 15.7557 5.42872 16 6 16ZM6 8C7.10457 8 8 7.10457 8 6C8 4.89543 7.10457 4 6 4C4.89543 4 4 4.89543 4 6C4 7.10457 4.89543 8 6 8Z',
                evenodd: true,
            },
        ],
    },
    bike: {
        viewBox: '0 0 16 16',
        paths: [
            {
                d:
                    'M12 10.083C11.6685 10.083 11.3505 10.2147 11.1161 10.4491C10.8817 10.6835 10.75 11.0015 10.75 11.333C10.75 11.6645 10.8817 11.9825 11.1161 12.2169C11.3505 12.4513 11.6685 12.583 12 12.583C12.3315 12.583 12.6495 12.4513 12.8839 12.2169C13.1183 11.9825 13.25 11.6645 13.25 11.333C13.25 11.0015 13.1183 10.6835 12.8839 10.4491C12.6495 10.2147 12.3315 10.083 12 10.083ZM9.25 11.333C9.25 10.6037 9.53973 9.90418 10.0555 9.38845C10.5712 8.87273 11.2707 8.583 12 8.583C12.7293 8.583 13.4288 8.87273 13.9445 9.38845C14.4603 9.90418 14.75 10.6037 14.75 11.333C14.75 12.0623 14.4603 12.7618 13.9445 13.2775C13.4288 13.7933 12.7293 14.083 12 14.083C11.2707 14.083 10.5712 13.7933 10.0555 13.2775C9.53973 12.7618 9.25 12.0623 9.25 11.333ZM4 10.083C3.66848 10.083 3.35054 10.2147 3.11612 10.4491C2.8817 10.6835 2.75 11.0015 2.75 11.333C2.75 11.6645 2.8817 11.9825 3.11612 12.2169C3.35054 12.4513 3.66848 12.583 4 12.583C4.33152 12.583 4.64946 12.4513 4.88388 12.2169C5.1183 11.9825 5.25 11.6645 5.25 11.333C5.25 11.0015 5.1183 10.6835 4.88388 10.4491C4.64946 10.2147 4.33152 10.083 4 10.083ZM1.25 11.333C1.25 10.6037 1.53973 9.90418 2.05546 9.38845C2.57118 8.87273 3.27065 8.583 4 8.583C4.72935 8.583 5.42882 8.87273 5.94454 9.38845C6.46027 9.90418 6.75 10.6037 6.75 11.333C6.75 12.0623 6.46027 12.7618 5.94454 13.2775C5.42882 13.7933 4.72935 14.083 4 14.083C3.27065 14.083 2.57118 13.7933 2.05546 13.2775C1.53973 12.7618 1.25 12.0623 1.25 11.333Z',
                evenodd: false,
            },
            {
                d:
                    'M7.47 5.136C7.59266 5.01359 7.75393 4.93744 7.92639 4.92049C8.09884 4.90354 8.27185 4.94682 8.416 5.043L8.643 5.195C9.034 5.458 9.25 5.604 9.548 5.712C9.885 5.834 10.365 5.917 11.333 5.917C11.5319 5.917 11.7227 5.99601 11.8633 6.13667C12.004 6.27732 12.083 6.46808 12.083 6.667C12.083 6.86591 12.004 7.05667 11.8633 7.19733C11.7227 7.33798 11.5319 7.417 11.333 7.417C10.301 7.417 9.615 7.332 9.035 7.122C8.8951 7.07003 8.75822 7.01026 8.625 6.943C8.346 7.331 7.957 7.741 7.556 8.029C8.32018 8.96135 8.74161 10.1275 8.75 11.333V11.999C8.75013 12.1979 8.67124 12.3887 8.53068 12.5295C8.39012 12.6702 8.19941 12.7494 8.0005 12.7495C7.80159 12.7496 7.61077 12.6707 7.47002 12.5302C7.32928 12.3896 7.25013 12.1989 7.25 12V11.333C7.25 10.228 6.703 9.115 5.904 8.503C5.423 8.134 5.256 7.35 5.777 6.829L7.47 5.136ZM10.667 3.333C10.667 3.68666 10.5265 4.02584 10.2764 4.27592C10.0263 4.526 9.68717 4.6665 9.3335 4.6665C8.97983 4.6665 8.64065 4.526 8.39057 4.27592C8.14049 4.02584 8 3.68666 8 3.333C8 2.97933 8.14049 2.64015 8.39057 2.39007C8.64065 2.13999 8.97983 1.9995 9.3335 1.9995C9.68717 1.9995 10.0263 2.13999 10.2764 2.39007C10.5265 2.64015 10.667 2.97933 10.667 3.333ZM6.256 2.98C6.17863 2.9025 6.08674 2.84102 5.98559 2.79907C5.88444 2.75713 5.77601 2.73554 5.6665 2.73554C5.55699 2.73554 5.44856 2.75713 5.34741 2.79907C5.24626 2.84102 5.15437 2.9025 5.077 2.98L3.147 4.91C3.06935 4.98738 3.00775 5.07934 2.96571 5.18058C2.92368 5.28183 2.90204 5.39037 2.90204 5.5C2.90204 5.60962 2.92368 5.71817 2.96571 5.81941C3.00775 5.92066 3.06935 6.01261 3.147 6.09L3.744 6.687C3.82137 6.76449 3.91326 6.82597 4.01441 6.86792C4.11556 6.90987 4.22399 6.93146 4.3335 6.93146C4.44301 6.93146 4.55144 6.90987 4.65259 6.86792C4.75374 6.82597 4.84563 6.76449 4.923 6.687L6.853 4.756C6.9305 4.67863 6.99197 4.58674 7.03392 4.48559C7.07587 4.38443 7.09746 4.276 7.09746 4.1665C7.09746 4.05699 7.07587 3.94856 7.03392 3.84741C6.99197 3.74625 6.9305 3.65437 6.853 3.577L6.256 2.98Z',
                evenodd: false,
            },
        ],
    },
    list: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M4 16.5C4.82843 16.5 5.5 17.1716 5.5 18C5.49993 18.8284 4.82839 19.5 4 19.5C3.17173 19.4999 2.50007 18.8283 2.5 18C2.5 17.1717 3.17169 16.5001 4 16.5Z',
                evenodd: false,
            },
            {
                d:
                    'M21 17C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H9C8.44783 18.9999 8 18.5522 8 18C8 17.4478 8.44783 17.0001 9 17H21Z',
                evenodd: false,
            },
            {
                d:
                    'M4 10.5C4.82843 10.5 5.5 11.1716 5.5 12C5.49993 12.8284 4.82839 13.5 4 13.5C3.17173 13.4999 2.50007 12.8283 2.5 12C2.5 11.1717 3.17169 10.5001 4 10.5Z',
                evenodd: false,
            },
            {
                d:
                    'M21 11C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H9C8.44783 12.9999 8 12.5522 8 12C8 11.4478 8.44783 11.0001 9 11H21Z',
                evenodd: false,
            },
            {
                d:
                    'M4 4.5C4.82843 4.5 5.5 5.17157 5.5 6C5.49993 6.82837 4.82839 7.5 4 7.5C3.17173 7.49987 2.50007 6.82829 2.5 6C2.5 5.17165 3.17169 4.50013 4 4.5Z',
                evenodd: false,
            },
            {
                d:
                    'M21 5C21.5523 5 22 5.44772 22 6C21.9999 6.55223 21.5522 7 21 7H9C8.44787 6.99987 8.00007 6.55215 8 6C8 5.4478 8.44783 5.00013 9 5H21Z',
                evenodd: false,
            },
        ],
    },
    groups: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M8.50049 12C10.5178 12.0001 12.1775 12.4604 13.7319 13.2793C15.2706 14.0901 16.0005 15.7342 16.0005 17.3027V20C16.0004 21.1043 15.1047 21.9997 14.0005 22H3.00049C1.96494 22 1.11363 21.2126 1.01123 20.2041L0.999512 20V17.3018C0.999512 15.7326 1.7309 14.0876 3.271 13.2773C4.82528 12.4597 6.48482 12 8.50049 12ZM8.50049 14C6.82249 14 5.48098 14.3748 4.20166 15.0479C3.46346 15.4364 3.00049 16.2965 3.00049 17.3018V20H14.0005V17.3027C14.0005 16.298 13.5371 15.4378 12.7993 15.0488C11.5202 14.375 10.1793 14.0001 8.50049 14Z',
                evenodd: true,
            },
            {
                d:
                    'M16.9067 13.0342C17.0326 12.4967 17.5703 12.1625 18.1079 12.2881C19.0457 12.5072 19.9074 12.8449 20.7319 13.2793C22.2705 14.09 23.0003 15.7334 23.0005 17.3018V19.999C23.0005 21.1034 22.1048 21.9988 21.0005 21.999H18.8999C18.3476 21.999 17.8999 21.5513 17.8999 20.999C17.9003 20.4471 18.3479 19.999 18.8999 19.999H21.0005V17.3018C21.0003 16.2971 20.5371 15.4376 19.7993 15.0488C19.1084 14.6849 18.4066 14.4115 17.6528 14.2354C17.1151 14.1097 16.7811 13.572 16.9067 13.0342Z',
                evenodd: false,
            },
            {
                d:
                    'M8.50049 2C10.9856 2.00026 13.0005 4.01488 13.0005 6.5C13.0004 8.98504 10.9855 10.9997 8.50049 11C6.01529 11 4.00062 8.9852 4.00049 6.5C4.00049 4.01472 6.0152 2 8.50049 2ZM8.50049 4C7.11977 4 6.00049 5.11929 6.00049 6.5C6.00062 7.88062 7.11985 9 8.50049 9C9.88092 8.99974 11.0004 7.88047 11.0005 6.5C11.0005 5.11944 9.881 4.00026 8.50049 4Z',
                evenodd: true,
            },
            {
                d:
                    'M15.4995 2C17.9848 2 19.9995 4.01472 19.9995 6.5C19.9994 8.9852 17.9847 11 15.4995 11C15.3423 11 15.1864 10.9915 15.0327 10.9756C14.4836 10.9186 14.0835 10.4271 14.1401 9.87793C14.1971 9.32897 14.6888 8.92987 15.2378 8.98633C15.3233 8.99518 15.411 8.99998 15.4995 9C16.8802 9 17.9994 7.88063 17.9995 6.5C17.9995 5.11928 16.8802 4 15.4995 4C15.411 4.00002 15.3233 4.00482 15.2378 4.01367C14.6889 4.0701 14.1972 3.67091 14.1401 3.12207C14.0833 2.57281 14.4835 2.08139 15.0327 2.02441C15.1864 2.00852 15.3423 2.00002 15.4995 2Z',
                evenodd: false,
            },
        ],
    },
    person: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M11.998 12C14.4004 12 16.6717 12.5684 18.6777 13.5771C20.2474 14.3665 20.9999 16.0175 21 17.6035V21C21 22.1046 20.1046 23 19 23H5C3.89543 23 3 22.1046 3 21V17.6016C3.00011 16.0151 3.75286 14.3632 5.32324 13.5742C7.32808 12.567 9.59764 12.0001 11.998 12ZM11.998 14C9.9155 14.0001 7.95246 14.4913 6.2207 15.3613C5.47215 15.7375 5.00011 16.5928 5 17.6016V21H19V17.6035C18.9999 16.5949 18.5277 15.7396 17.7793 15.3633C16.0466 14.492 14.0821 14 11.998 14Z',
                evenodd: true,
            },
            {
                d:
                    'M12 1C14.7614 1 16.9999 3.23869 17 6C17 8.76146 14.7615 11 12 11C9.23858 11 7 8.76146 7 6C7.00013 3.23869 9.23866 1 12 1ZM12 3C10.3432 3 9.00013 4.34326 9 6C9 7.65688 10.3431 9 12 9C13.6569 9 15 7.65689 15 6C14.9999 4.34325 13.6568 3 12 3Z',
                evenodd: true,
            },
        ],
    },
    clock: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12ZM11 11.5859V7C11 6.44778 11.4478 6.00011 12 6C12.5523 6 13 6.44772 13 7V11.5859L16.207 14.793C16.5976 15.1835 16.5976 15.8165 16.207 16.207C15.8165 16.5974 15.1834 16.5975 14.793 16.207L11.5859 13C11.2109 12.625 11.0001 12.1162 11 11.5859ZM23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z',
                evenodd: false,
            },
        ],
    },
    warning: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M11.9992 15.5047C12.8276 15.5047 13.4992 16.1763 13.4992 17.0047C13.4991 17.8331 12.8275 18.5047 11.9992 18.5047C11.171 18.5046 10.4993 17.833 10.4992 17.0047C10.4992 16.1764 11.1709 15.5049 11.9992 15.5047Z',
                evenodd: false,
            },
            {
                d:
                    'M11.9992 8.00475C12.5515 8.00475 12.9992 8.45246 12.9992 9.00475V13.0047C12.9991 13.5569 12.5514 14.0047 11.9992 14.0047C11.4471 14.0046 10.9993 13.5568 10.9992 13.0047V9.00475C10.9992 8.45255 11.447 8.00489 11.9992 8.00475Z',
                evenodd: false,
            },
            {
                d:
                    'M10.2472 2.11608C11.0071 0.734662 12.9913 0.734667 13.7511 2.11608L23.0607 19.0409C23.7935 20.3737 22.8289 22.0047 21.3078 22.0047H2.6906C1.16956 22.0047 0.204953 20.3737 0.93767 19.0409L10.2472 2.11608ZM2.6906 20.0047H21.3078L11.9992 3.07994L2.6906 20.0047Z',
                evenodd: true,
            },
        ],
    },
    'alert-circle': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M12 15C12.8284 15 13.5 15.6716 13.5 16.5C13.4999 17.3284 12.8284 18 12 18C11.1717 17.9999 10.5001 17.3283 10.5 16.5C10.5 15.6717 11.1717 15.0001 12 15Z',
                evenodd: false,
            },
            {
                d:
                    'M12 6.5C12.5523 6.5 13 6.94772 13 7.5V12.5C13 13.0523 12.5523 13.5 12 13.5C11.4477 13.5 11 13.0523 11 12.5V7.5C11 6.94772 11.4477 6.5 12 6.5Z',
                evenodd: false,
            },
            {
                d:
                    'M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z',
                evenodd: true,
            },
        ],
    },
    info: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M12 10C12.5523 10 13 10.4477 13 11V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V11C11 10.4477 11.4477 10 12 10Z',
                evenodd: false,
            },
            {
                d:
                    'M12 5.5C12.8284 5.5 13.5 6.17157 13.5 7C13.4999 7.82831 12.8283 8.5 12 8.5C11.1717 8.5 10.5001 7.82831 10.5 7C10.5 6.17157 11.1716 5.5 12 5.5Z',
                evenodd: false,
            },
            {
                d:
                    'M12 1C18.0751 1 23 5.92487 23 12C22.9999 18.0751 18.0751 23 12 23C5.92491 23 1.00007 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM12 3C7.02944 3 3 7.02944 3 12C3.00007 16.9705 7.02948 21 12 21C16.9705 21 20.9999 16.9705 21 12C21 7.02944 16.9706 3 12 3Z',
                evenodd: true,
            },
        ],
    },
    receipt: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M5 2.99988V20.4608L8.09375 19.0858L8.55664 18.8807L12 20.8475L15.4434 18.8807L15.9062 19.0858L19 20.4608V2.99988H5ZM16 10.9999C16.5523 10.9999 17 11.4476 17 11.9999C17 12.5522 16.5523 12.9999 16 12.9999H8C7.44772 12.9999 7 12.5522 7 11.9999C7 11.4476 7.44772 10.9999 8 10.9999H16ZM16 6.99988C16.5523 6.99988 17 7.44759 17 7.99988C17 8.55216 16.5523 8.99988 16 8.99988H8C7.44772 8.99988 7 8.55216 7 7.99988C7 7.44759 7.44772 6.99988 8 6.99988H16ZM21 21.9999C21 22.3384 20.8288 22.6543 20.5449 22.8387C20.2611 23.0231 19.903 23.0514 19.5938 22.9139L15.5557 21.119L12.4961 22.868C12.1887 23.0437 11.8113 23.0437 11.5039 22.868L8.44336 21.119L4.40625 22.9139C4.09698 23.0514 3.73889 23.0231 3.45508 22.8387C3.17124 22.6543 3 22.3384 3 21.9999V2.99988C3 1.89531 3.89543 0.999878 5 0.999878H19C20.1046 0.999878 21 1.89531 21 2.99988V21.9999Z',
                evenodd: false,
            },
        ],
    },
    send: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M20.3051 2.30176C21.0429 2.35161 21.6478 2.95563 21.6977 3.69336L21.7084 3.7041L21.6987 3.71289C21.7087 3.89752 21.6848 4.09016 21.6186 4.28418L15.5268 22.124C15.025 23.5935 13.0008 23.7302 12.3061 22.3418L8.75531 15.2422L1.65766 11.6934C0.26867 10.9989 0.404849 8.97351 1.87445 8.47168L19.7143 2.37988C19.9079 2.31377 20.1003 2.28997 20.2846 2.2998L20.2944 2.29004L20.3051 2.30176ZM10.7172 14.6943L13.8266 20.9121L18.6635 6.74805L10.7172 14.6943ZM3.08539 10.1709L9.30414 13.2803L17.2495 5.33398L3.08539 10.1709Z',
                evenodd: false,
            },
        ],
    },
    'external-link': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M2 18V6C2 3.79086 3.79086 2 6 2H10C10.5523 2 11 2.44772 11 3C11 3.55228 10.5523 4 10 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V14C20 13.4477 20.4477 13 21 13C21.5523 13 22 13.4477 22 14V18C22 20.2091 20.2091 22 18 22H6C3.79086 22 2 20.2091 2 18ZM20 9V5.41406L12.207 13.207C11.8165 13.5976 11.1835 13.5976 10.793 13.207C10.4024 12.8165 10.4024 12.1835 10.793 11.793L18.5859 4H15C14.4477 4 14 3.55228 14 3C14 2.44772 14.4477 2 15 2H20C21.1046 2 22 2.89543 22 4V9C22 9.55228 21.5523 10 21 10C20.4477 10 20 9.55228 20 9Z',
                evenodd: true,
            },
        ],
    },
    'external-link-16': {
        viewBox: '0 0 16 16',
        paths: [
            {
                d:
                    'M6 1C6.55228 1 7 1.44772 7 2C7 2.55228 6.55228 3 6 3H4C3.44772 3 3 3.44772 3 4V12C3 12.5523 3.44772 13 4 13H12C12.5523 13 13 12.5523 13 12V10C13 9.44772 13.4477 9 14 9C14.5523 9 15 9.44772 15 10V12C15 13.6569 13.6569 15 12 15H4C2.34315 15 1 13.6569 1 12V4C1 2.34315 2.34315 1 4 1H6Z',
                evenodd: true,
            },
            {
                d:
                    'M13.333 1C14.2535 1 15 1.74652 15 2.66699V6C15 6.55228 14.5523 7 14 7C13.4477 7 13 6.55228 13 6V4.41406L8.20703 9.20703C7.81654 9.59726 7.18343 9.59731 6.79297 9.20703C6.40271 8.81657 6.40275 8.18345 6.79297 7.79297L11.5859 3H10C9.44771 3 9 2.55228 9 2C9 1.44772 9.44771 1 10 1H13.333Z',
                evenodd: true,
            },
        ],
    },
    search: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17C13.866 17 17 13.866 17 10ZM19 10C19 12.125 18.2619 14.0766 17.0303 15.6162L22.707 21.293C23.0975 21.6835 23.0975 22.3165 22.707 22.707C22.3165 23.0975 21.6835 23.0975 21.293 22.707L15.6162 17.0303C14.0766 18.2619 12.125 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z',
                evenodd: false,
            },
        ],
    },
    message: {
        viewBox: '0 0 16 16',
        paths: [
            {
                d:
                    'M15.8195 15.1912C16 14.9331 16 14.5045 16 13.6472L16 5.55375C16.0001 5.31551 16.0002 5.031 15.9798 4.78036C15.956 4.48993 15.8951 4.07394 15.673 3.63805C15.3854 3.07357 14.9265 2.61463 14.362 2.32701C13.9261 2.10491 13.5101 2.04402 13.2197 2.02029C12.969 1.99981 12.6845 1.99992 12.4463 2.00001L3.55375 2.00001C3.31551 1.99992 3.031 1.99981 2.78036 2.02029C2.48993 2.04402 2.07395 2.10491 1.63805 2.327C1.07357 2.61462 0.614625 3.07357 0.327006 3.63805C0.104907 4.07394 0.0440209 4.48993 0.0202916 4.78036C-0.000186699 5.031 -7.89451e-05 5.31551 1.25972e-05 5.55375L1.2427e-05 9.4463C-7.91361e-05 9.68454 -0.000186915 9.96905 0.0202913 10.2197C0.0440206 10.5101 0.104907 10.9261 0.327005 11.362C0.614625 11.9265 1.07357 12.3854 1.63805 12.673C2.07395 12.8951 2.48993 12.956 2.78036 12.9798C3.031 13.0002 3.31551 13.0001 3.55375 13L9.52789 13L13.6845 15.0783C14.4512 15.4617 14.8346 15.6534 15.1462 15.6073C15.4183 15.5671 15.6618 15.4166 15.8195 15.1912ZM4.24999 5.00003C3.55963 5.00003 2.99999 5.55968 2.99999 6.25003C2.99999 6.94039 3.55963 7.50003 4.24999 7.50003H9.74999C10.4403 7.50003 11 6.94039 11 6.25003C11 5.55968 10.4403 5.00003 9.74999 5.00003H4.24999Z',
                evenodd: true,
            },
        ],
    },
    dot: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d: 'M4.0 12.0a8.0 8.0 0 1 0 16.0 0a8.0 8.0 0 1 0 -16.0 0Z',
                evenodd: false,
            },
        ],
    },
    banknote: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8ZM12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z',
                evenodd: true,
            },
            {
                d:
                    'M20 5C21.6569 5 23 6.34315 23 8V16C23 17.6569 21.6569 19 20 19H4C2.34315 19 1 17.6569 1 16V8C1 6.34315 2.34315 5 4 5H20ZM3 16C3 16.5523 3.44772 17 4 17H4.82617C4.52483 16.1484 3.85162 15.4752 3 15.1738V16ZM21 15.1738C20.1484 15.4752 19.4752 16.1484 19.1738 17H20C20.5523 17 21 16.5523 21 16V15.1738ZM6.89941 7C6.5017 8.95904 4.95904 10.5017 3 10.8994V13.0996C4.95913 13.4973 6.50169 15.0409 6.89941 17H17.1006C17.4983 15.0409 19.0409 13.4973 21 13.0996V10.8994C19.041 10.5017 17.4983 8.95904 17.1006 7H6.89941ZM4 7C3.44772 7 3 7.44772 3 8V8.8252C3.85148 8.5238 4.52487 7.85152 4.82617 7H4ZM19.1738 7C19.4751 7.85152 20.1485 8.5238 21 8.8252V8C21 7.44772 20.5523 7 20 7H19.1738Z',
                evenodd: true,
            },
        ],
    },
    swap: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M7.79306 12.793C8.18359 12.4025 8.81662 12.4025 9.20712 12.793C9.59755 13.1835 9.59755 13.8165 9.20712 14.207L6.41415 17H19.5001C20.0523 17.0001 20.5001 17.4478 20.5001 18C20.5001 18.5522 20.0523 18.9999 19.5001 19H6.41415L9.20712 21.793C9.59755 22.1835 9.59755 22.8165 9.20712 23.207C8.81662 23.5975 8.18359 23.5975 7.79306 23.207L4.00009 19.4141C3.21905 18.633 3.21904 17.367 4.00009 16.5859L7.79306 12.793ZM14.7931 0.792977C15.1836 0.402529 15.8166 0.402478 16.2071 0.792977L20.0001 4.58595C20.7809 5.36696 20.7809 6.63306 20.0001 7.41407L16.2071 11.207C15.8166 11.5975 15.1836 11.5975 14.7931 11.207C14.4025 10.8165 14.4025 10.1835 14.7931 9.79298L17.586 7.00001H4.50009C3.94781 7.00001 3.50009 6.55229 3.50009 6.00001C3.50009 5.44772 3.94781 5.00001 4.50009 5.00001H17.586L14.7931 2.20704C14.4025 1.81652 14.4025 1.1835 14.7931 0.792977Z',
                evenodd: false,
            },
        ],
    },
    email: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M22 9.13622C22.0001 8.63145 22.0001 8.13987 21.9661 7.72355C21.9288 7.26636 21.8406 6.7269 21.564 6.18405C21.1805 5.4314 20.5686 4.81948 19.816 4.43598C19.2731 4.15939 18.7337 4.07125 18.2765 4.0339C17.8602 3.99989 17.3686 3.99995 16.8638 4.00001L7.13621 4C6.63146 3.99994 6.13986 3.99989 5.72355 4.0339C5.26636 4.07125 4.72689 4.15939 4.18405 4.43598C3.4314 4.81948 2.81948 5.4314 2.43598 6.18405C2.15939 6.7269 2.07125 7.26636 2.0339 7.72355C1.99989 8.13988 1.99994 8.63147 2.00001 9.13625L2.00001 14.8638C1.99994 15.3685 1.99988 15.8601 2.0339 16.2765C2.07125 16.7337 2.15939 17.2731 2.43598 17.816C2.81948 18.5686 3.4314 19.1805 4.18405 19.564C4.72689 19.8406 5.26636 19.9288 5.72355 19.9661C6.13986 20.0001 6.63145 20.0001 7.13621 20H16.8638C17.3686 20.0001 17.8601 20.0001 18.2765 19.9661C18.7337 19.9288 19.2731 19.8406 19.816 19.564C20.5686 19.1805 21.1805 18.5686 21.564 17.816C21.8406 17.2731 21.9288 16.7337 21.9661 16.2765C22.0001 15.8602 22.0001 15.3686 22 14.8639V9.13622ZM16.8 6.00001C17.9201 6.00001 18.4802 6.00001 18.908 6.218C19.2843 6.40974 19.5903 6.71571 19.782 7.09203C19.8042 7.13549 19.8241 7.18032 19.8419 7.22697L12.0001 11.8398L4.15809 7.22692C4.17597 7.1803 4.19586 7.13548 4.218 7.09203C4.40974 6.7157 4.7157 6.40974 5.09203 6.218C5.51985 6.00001 6.0799 6.00001 7.20001 6.00001L16.8 6.00001ZM4.00001 9.45429L11.493 13.862C11.806 14.046 12.1941 14.046 12.5071 13.862L20 9.45435L20 14.8C20 15.9201 20 16.4802 19.782 16.908C19.5903 17.2843 19.2843 17.5903 18.908 17.782C18.4802 18 17.9201 18 16.8 18L7.20001 18C6.0799 18 5.51985 18 5.09203 17.782C4.7157 17.5903 4.40974 17.2843 4.218 16.908C4.00001 16.4802 4.00001 15.9201 4.00001 14.8L4.00001 9.45429Z',
                evenodd: true,
            },
        ],
    },
    phone: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M3.13072 6.11845C2.90975 4.34182 4.38184 3 5.99991 3H7.41632C8.80817 3 10.0172 3.95733 10.3364 5.3121L10.7696 7.15119C11.0886 8.50495 10.4352 9.90039 9.19122 10.5224L7.05827 11.5889C8.35601 13.7969 10.203 15.6439 12.4111 16.9416L13.4775 14.8087C14.0995 13.5647 15.495 12.9114 16.8487 13.2303L18.6878 13.6635C20.0426 13.9827 20.9999 15.1917 20.9999 16.5836V18C20.9999 19.6181 19.6581 21.0902 17.8815 20.8692C15.9312 20.6266 14.0829 20.0536 12.395 19.208C9.1121 17.5634 6.43652 14.8878 4.79187 11.6049C3.9463 9.91705 3.3733 8.06874 3.13072 6.11845ZM14.1992 17.8375C15.4335 18.3556 16.7518 18.7133 18.1283 18.8845C18.5439 18.9362 18.9999 18.5911 18.9999 18V16.5836C18.9999 16.1196 18.6808 15.7166 18.2292 15.6102L16.3901 15.177C15.9389 15.0707 15.4737 15.2885 15.2664 15.7031L14.1992 17.8375ZM6.16241 9.80072L8.29679 8.73353C8.71145 8.5262 8.92923 8.06105 8.82293 7.6098L8.38968 5.7707C8.28329 5.31911 7.88027 5 7.41632 5H5.99991C5.40885 5 5.06374 5.45597 5.11543 5.87159C5.28664 7.24809 5.64431 8.56637 6.16241 9.80072Z',
                evenodd: true,
            },
        ],
    },
    calendar: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M16 1C16.5521 1.00013 16.9998 1.44796 17 2V3H18C20.2089 3.00013 21.9998 4.79111 22 7V19C22 21.2091 20.209 22.9999 18 23H6C3.79086 23 2 21.2091 2 19V7C2.0002 4.79103 3.79098 3 6 3H7V2C7.0002 1.44788 7.44784 1 8 1C8.55205 1.00013 8.9998 1.44796 9 2V3H15V2C15.0002 1.44788 15.4478 1 16 1ZM4 11V19C4 20.1046 4.89543 21 6 21H18C19.1045 20.9999 20 20.1045 20 19V11H4ZM6 5C4.89555 5 4.0002 5.8956 4 7V9H20V7C19.9998 5.89568 19.1043 5.00013 18 5H17V6C17 6.5522 16.5522 6.99987 16 7C15.4477 7 15 6.55228 15 6V5H9V6C9 6.5522 8.55217 6.99987 8 7C7.44772 7 7 6.55228 7 6V5H6Z',
                evenodd: true,
            },
        ],
    },
    menu: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M21 17C21.5522 17 21.9999 17.4478 22 18C22 18.5523 21.5523 19 21 19H3C2.44772 19 2 18.5523 2 18C2.00007 17.4478 2.44776 17 3 17H21ZM21 11C21.5522 11 21.9999 11.4478 22 12C22 12.5523 21.5523 13 21 13H3C2.44772 13 2 12.5523 2 12C2.00007 11.4478 2.44776 11 3 11H21ZM21 5C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H3C2.44772 7 2 6.55228 2 6C2 5.44772 2.44772 5 3 5H21Z',
                evenodd: false,
            },
        ],
    },
    eye: {
        viewBox: '0 0 16 16',
        paths: [
            {
                d:
                    'M10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8C6 6.89543 6.89543 6 8 6C9.10457 6 10 6.89543 10 8Z',
                evenodd: false,
            },
            {
                d:
                    'M0.147562 7.47717C1.95867 4.52428 4.74958 2.5 8 2.5C11.2504 2.5 14.0413 4.52428 15.8524 7.47717C16.0492 7.79796 16.0492 8.20204 15.8524 8.52283C14.0413 11.4757 11.2504 13.5 8 13.5C4.74958 13.5 1.95867 11.4757 0.147562 8.52283C-0.0491873 8.20204 -0.0491873 7.79796 0.147562 7.47717ZM12 8C12 10.2091 10.2091 12 8 12C5.79086 12 4 10.2091 4 8C4 5.79086 5.79086 4 8 4C10.2091 4 12 5.79086 12 8Z',
                evenodd: true,
            },
        ],
    },
    'eye-closed': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M4.70711 3.29289C4.31658 2.90237 3.68342 2.90237 3.29289 3.29289C2.90237 3.68342 2.90237 4.31658 3.29289 4.70711L6.71327 8.12749C5.02942 9.16186 3.64612 10.6498 2.74352 12.4325C2.55977 12.7958 2.55977 13.2256 2.74352 13.5889C4.39523 16.8505 7.85032 19.0107 12.0107 19.0107C13.9286 19.0107 15.7156 18.4716 17.2401 17.5493L19.2929 19.6021C19.6834 19.9926 20.3166 19.9926 20.7071 19.6021C21.0976 19.2116 21.0976 18.5784 20.7071 18.1879L4.70711 3.29289ZM15.7555 16.0647L13.8918 14.201C13.3357 14.5512 12.6849 14.75 12.0107 14.75C10.2158 14.75 8.76067 13.2949 8.76067 11.5C8.76067 10.8258 8.95949 10.175 9.30972 9.61893L7.77262 8.08183C6.40498 8.92258 5.28084 10.0742 4.50141 11.456C4.46308 11.5233 4.46308 11.5979 4.50141 11.6653C5.97814 14.2828 8.77894 16.0107 12.0107 16.0107C13.3437 16.0107 14.6085 15.6881 15.7555 16.0647ZM10.8259 11.1351C10.7848 11.2503 10.7607 11.3727 10.7607 11.5C10.7607 12.1904 11.3203 12.75 12.0107 12.75C12.138 12.75 12.2604 12.7259 12.3756 12.6848L10.8259 11.1351Z',
                evenodd: true,
            },
            {
                d:
                    'M19.5199 11.6653C18.8769 12.7951 17.9999 13.7709 16.9508 14.5216L18.3873 15.9581C19.5827 14.9858 20.5617 13.7589 21.2778 12.4325C21.4616 12.0692 21.4616 11.6394 21.2778 11.2761C19.6261 7.91449 16.0711 5.75 12.0107 5.75C10.8757 5.75 9.78116 5.93877 8.76067 6.29006L10.443 7.97236C10.9413 7.85081 11.4651 7.78571 12.0107 7.78571C15.2424 7.78571 18.0432 9.51362 19.5199 12.1311C19.5583 12.1984 19.5583 12.2729 19.5199 12.3403V11.6653Z',
                evenodd: false,
            },
        ],
    },
    star: {
        viewBox: '0 0 16 16',
        paths: [
            {
                d:
                    'M8.91123 0.588193C8.74942 0.230121 8.3929 0 7.99996 0C7.60702 0 7.2505 0.230121 7.08869 0.588193L5.37313 4.38448L1.23251 4.84295C0.841962 4.8862 0.512933 5.15416 0.391509 5.52786C0.270085 5.90157 0.378772 6.31175 0.669316 6.5763L3.74967 9.381L2.90618 13.4606C2.82662 13.8454 2.97979 14.2412 3.29768 14.4721C3.61557 14.7031 4.03926 14.7265 4.38064 14.5319L7.99996 12.469L11.6193 14.5319C11.9607 14.7265 12.3843 14.7031 12.7022 14.4721C13.0201 14.2412 13.1733 13.8454 13.0937 13.4606L12.2503 9.381L15.3306 6.5763C15.6212 6.31175 15.7298 5.90157 15.6084 5.52786C15.487 5.15416 15.158 4.8862 14.7674 4.84295L10.6268 4.38448L8.91123 0.588193Z',
                evenodd: false,
            },
        ],
    },
    home: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M10.741 1.73536C11.4748 1.14155 12.5249 1.14148 13.2586 1.73536L23.1287 9.7256C23.5578 10.073 23.6242 10.7026 23.2771 11.1318C22.9297 11.561 22.3001 11.6276 21.8709 11.2803L20.9998 10.5742V21.0029C20.9998 22.1075 20.1044 23.0029 18.9998 23.0029H4.9998C3.89535 23.0028 2.9998 22.1074 2.9998 21.0029V10.5742L2.12871 11.2803C1.69945 11.6276 1.06989 11.561 0.722455 11.1318C0.375291 10.7026 0.441754 10.073 0.870893 9.7256L10.741 1.73536ZM4.94218 9.00294H4.9998V21.0029H7.9998V17.0029C8.00006 14.7941 9.79095 13.0031 11.9998 13.0029C14.2088 13.0029 15.9995 14.794 15.9998 17.0029V21.0029H18.9998V9.00294H19.0574L11.9998 3.28907L4.94218 9.00294ZM11.9998 15.0029C10.8955 15.0031 10.0001 15.8987 9.9998 17.0029V21.0029H13.9998V17.0029C13.9995 15.8986 13.1042 15.0029 11.9998 15.0029Z',
                evenodd: true,
            },
        ],
    },
    gear: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M19.0003 12C19.0003 11.6453 18.9737 11.2974 18.9231 10.958L18.8392 10.3975L19.2767 10.0381L20.6204 8.93164L18.9681 6.06836L16.805 6.87891L16.3616 6.52539C15.8199 6.09316 15.2131 5.73958 14.5589 5.48242L14.0315 5.27539L13.6526 3H10.347L9.96807 5.27539L9.44072 5.48242C8.7865 5.73957 8.17965 6.09319 7.63799 6.52539L7.19463 6.87891L5.03252 6.06836L3.3792 8.93164L4.72295 10.0381L5.16045 10.3975L5.07646 10.958C5.02587 11.2974 5.00029 11.6453 5.00029 12C5.00029 12.3549 5.02581 12.7033 5.07646 13.043L5.16045 13.6025L4.72295 13.9619L3.3792 15.0684L5.03252 17.9316L7.19463 17.1211L7.63799 17.4756C8.11194 17.8537 8.63576 18.1713 9.19756 18.417L9.44072 18.5176L9.96807 18.7246L10.347 21H13.6526L14.0315 18.7246L14.5589 18.5176C15.213 18.2605 15.8201 17.9076 16.3616 17.4756L16.805 17.1211L18.9681 17.9316L20.6204 15.0684L19.2767 13.9619L18.8392 13.6025L18.9231 13.043C18.9738 12.7034 19.0003 12.3548 19.0003 12ZM14.0003 12C14.0003 10.8956 13.1046 10.0003 12.0003 10C10.8957 10 10.0003 10.8954 10.0003 12C10.0003 13.1046 10.8957 14 12.0003 14C13.1046 13.9997 14.0003 13.1044 14.0003 12ZM16.0003 12C16.0003 14.209 14.2092 15.9997 12.0003 16C9.79115 16 8.00029 14.2091 8.00029 12C8.00029 9.79086 9.79115 8 12.0003 8C14.2092 8.00025 16.0003 9.79102 16.0003 12ZM21.0003 12C21.0003 12.2568 20.9873 12.511 20.9661 12.7627L21.8919 13.5244C22.6466 14.1457 22.8414 15.2217 22.3528 16.0684L20.6995 18.9316C20.2106 19.7782 19.1814 20.1477 18.2659 19.8047L17.1438 19.3838C16.7276 19.6742 16.2855 19.9295 15.8216 20.1475L15.6253 21.3291C15.4644 22.2933 14.6302 23 13.6526 23H10.347C9.3694 23 8.53518 22.2933 8.37432 21.3291L8.17705 20.1475C7.71347 19.9296 7.27172 19.6741 6.85576 19.3838L5.73369 19.8047C4.81822 20.1475 3.78891 19.7782 3.3001 18.9316L1.64678 16.0684C1.1583 15.2218 1.35319 14.1457 2.10771 13.5244L3.03252 12.7627C3.01137 12.5111 3.00029 12.2567 3.00029 12C3.00029 11.743 3.01132 11.4883 3.03252 11.2363L2.10771 10.4756C1.3532 9.85423 1.15818 8.7782 1.64678 7.93164L3.3001 5.06836C3.78895 4.22191 4.8183 3.85251 5.73369 4.19531L6.85478 4.61523C7.27091 4.32483 7.71325 4.06948 8.17705 3.85156L8.37432 2.6709C8.53518 1.70669 9.3694 1 10.347 1H13.6526C14.6302 1 15.4644 1.70669 15.6253 2.6709L15.8216 3.85059C16.2856 4.06851 16.7276 4.32478 17.1438 4.61523L18.2659 4.19531C19.1813 3.85239 20.2106 4.22194 20.6995 5.06836L22.3528 7.93164C22.8416 8.77828 22.6466 9.85423 21.8919 10.4756L20.9661 11.2363C20.9873 11.4883 21.0003 11.7429 21.0003 12Z',
                evenodd: false,
            },
        ],
    },
    help: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M12 15.5C12.8284 15.5 13.5 16.1716 13.5 17C13.4999 17.8283 12.8284 18.5 12 18.5C11.1716 18.5 10.5001 17.8283 10.5 17C10.5 16.1716 11.1716 15.5 12 15.5Z',
                evenodd: false,
            },
            {
                d:
                    'M12.0166 5C14.0648 5.00022 16 6.42635 16 8.81348C15.9997 11.0214 14.3707 12.1482 13.0225 12.6777C12.9823 12.6936 12.9557 12.7176 12.9424 12.7354C12.9315 12.7501 12.9335 12.7535 12.9336 12.748V13.5C12.9334 14.0521 12.4857 14.4999 11.9336 14.5C11.3816 14.4998 10.9338 14.052 10.9336 13.5V12.748C10.9337 11.8254 11.5507 11.1075 12.292 10.8164C13.3481 10.4016 13.9998 9.78708 14 8.81348C14 7.73773 13.179 7.0002 12.0166 7C11.0626 7 10.2361 7.63648 9.96191 8.59961C9.81049 9.13021 9.25734 9.43787 8.72656 9.28711C8.19556 9.13592 7.88719 8.58277 8.03809 8.05176C8.5437 6.27599 10.1212 5 12.0166 5Z',
                evenodd: false,
            },
            {
                d:
                    'M12 1C18.0751 1 23 5.92487 23 12C22.9999 18.075 18.0751 23 12 23C5.92493 23 1.0001 18.075 1 12C1 5.92487 5.92487 1 12 1ZM12 3C7.02944 3 3 7.02944 3 12C3.0001 16.9705 7.0295 21 12 21C16.9705 21 20.9999 16.9705 21 12C21 7.02944 16.9706 3 12 3Z',
                evenodd: true,
            },
        ],
    },
    lock: {
        viewBox: '0 0 16 16',
        paths: [
            {
                d:
                    'M8 10C8.55228 10 9 10.4477 9 11C9 11.5523 8.55228 12 8 12C7.44772 12 7 11.5523 7 11C7 10.4477 7.44772 10 8 10Z',
                evenodd: false,
            },
            {
                d:
                    'M8 1C10.2091 1 12 2.79086 12 5V6H12.333C13.2535 6 14 6.74652 14 7.66699V13C14 14.6569 12.6569 16 11 16H5C3.34315 16 2 14.6569 2 13V7.66699C2 6.74652 2.74652 6 3.66699 6H4V5C4 2.79086 5.79086 1 8 1ZM4 13C4 13.5523 4.44772 14 5 14H11C11.5523 14 12 13.5523 12 13V8H4V13ZM8 3C6.89543 3 6 3.89543 6 5V6H10V5C10 3.89543 9.10457 3 8 3Z',
                evenodd: true,
            },
        ],
    },
    'credit-card': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M2 7C2 5.89543 2.89543 5 4 5H20C21.1046 5 22 5.89543 22 7V9L2 9V7Z',
                evenodd: false,
            },
            {
                d:
                    'M2 11L22 11V17C22 18.1046 21.1046 19 20 19H4C2.89543 19 2 18.1046 2 17V11ZM16 14C15.4477 14 15 14.4477 15 15C15 15.5523 15.4477 16 16 16H18.5C19.0523 16 19.5 15.5523 19.5 15C19.5 14.4477 19.0523 14 18.5 14H16Z',
                evenodd: true,
            },
        ],
    },
    store: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M8.99994 14.75C9.82824 14.75 10.4997 15.4217 10.4999 16.25C10.4999 17.0784 9.82837 17.75 8.99994 17.75C8.17159 17.7499 7.49994 17.0784 7.49994 16.25C7.50014 15.4218 8.17172 14.7501 8.99994 14.75Z',
                evenodd: false,
            },
            {
                d:
                    'M19.412 2.00684C20.2346 2.07513 20.9387 2.64572 21.1689 3.4502L22.5976 8.4502C22.932 9.62048 22.1541 10.7831 20.9999 10.9707V21C20.9999 22.1046 20.1045 23 18.9999 23H4.99994C3.89545 22.9999 2.99994 22.1045 2.99994 21V10.9697C1.84603 10.7818 1.06797 9.62031 1.40228 8.4502L2.83099 3.4502C3.07644 2.59209 3.86132 2.00025 4.75385 2H19.246L19.412 2.00684ZM4.99994 21H12.9999V11H4.99994V21ZM14.9999 21H18.9999V11H14.9999V21ZM3.32611 9H20.6738L19.246 4H4.75385L3.32611 9Z',
                evenodd: true,
            },
        ],
    },
    tag: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M13.7429 1C12.4168 1 11.1445 1.52716 10.2068 2.46484L1.58569 11.0859C0.804747 11.867 0.804743 13.133 1.58569 13.9141L10.1716 22.5C10.9527 23.2809 12.2187 23.2809 12.9998 22.5L21.6208 13.8789C22.5585 12.9412 23.0857 11.6689 23.0857 10.3428V5C23.0857 2.79086 21.2948 1 19.0857 1H13.7429ZM21.0857 10.3428C21.0857 11.1384 20.7694 11.9022 20.2068 12.4648L11.5857 21.0859L2.99976 12.5L11.6208 3.87891C12.1835 3.3163 12.9473 3 13.7429 3H19.0857C20.1903 3 21.0857 3.89543 21.0857 5V10.3428Z',
                evenodd: false,
            },
            {
                d:
                    'M15.0857 7.5C15.0857 8.32843 15.7573 9 16.5857 9C17.4141 9 18.0857 8.32843 18.0857 7.5C18.0857 6.67157 17.4141 6 16.5857 6C15.7573 6 15.0857 6.67157 15.0857 7.5Z',
                evenodd: false,
            },
        ],
    },
    gift: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M5.92838 7.01344C4.87173 4.37181 7.26759 1.58176 10.0572 2.34257C10.864 2.56261 11.544 3.05869 12 3.71728C12.456 3.05869 13.136 2.56261 13.9428 2.34257C16.7324 1.58176 19.1283 4.37181 18.0716 7.01344C17.9263 7.37669 17.7226 7.70928 17.4725 7.99988C17.7052 7.99982 17.9782 8.00044 18.2197 8.02017C18.5101 8.0439 18.9261 8.10478 19.362 8.32688C19.9265 8.6145 20.3854 9.07344 20.673 9.63793C20.8951 10.0738 20.956 10.4898 20.9798 10.7802C21.0002 11.0309 21.0001 11.3154 21 11.5536V17.4462C21.0001 17.6844 21.0002 17.9689 20.9798 18.2196C20.956 18.51 20.8951 18.926 20.673 19.3619C20.3854 19.9264 19.9265 20.3853 19.362 20.6729C18.9261 20.895 18.5101 20.9559 18.2197 20.9796C17.9691 21.0001 17.6846 21 17.4463 20.9999H6.55375C6.31552 21 6.03099 21.0001 5.78036 20.9796C5.48993 20.9559 5.07394 20.895 4.63805 20.6729C4.07357 20.3853 3.61462 19.9264 3.327 19.3619C3.10491 18.926 3.04402 18.51 3.02029 18.2196C2.99981 17.9689 2.99992 17.6844 3.00001 17.4462V11.5536C2.99992 11.3154 2.99981 11.0309 3.02029 10.7802C3.04402 10.4898 3.10491 10.0738 3.327 9.63793C3.61462 9.07344 4.07357 8.6145 4.63805 8.32688C5.07394 8.10478 5.48993 8.0439 5.78036 8.02017C6.02186 8.00044 6.29481 7.99982 6.5275 7.99988C6.27735 7.70928 6.07368 7.37669 5.92838 7.01344ZM9.53097 4.27209C8.37893 3.9579 7.32463 5.11889 7.78534 6.27066C7.96474 6.71916 8.35082 7.05678 8.81281 7.17228L10.8473 7.68089L10.6085 5.5318C10.5417 4.93064 10.1145 4.43124 9.53097 4.27209ZM5.00002 11.5999C5.00002 11.0399 5.00002 10.7598 5.10902 10.5459C5.20489 10.3577 5.35787 10.2048 5.54603 10.1089C5.75995 9.9999 6.03997 9.9999 6.60002 9.9999H11V18.9999H6.60002C6.03997 18.9999 5.75995 18.9999 5.54603 18.8909C5.35787 18.795 5.20489 18.6421 5.10902 18.4539C5.00002 18.24 5.00002 17.96 5.00002 17.3999V11.5999ZM13 18.9999H17.4C17.9601 18.9999 18.2401 18.9999 18.454 18.8909C18.6422 18.795 18.7952 18.6421 18.891 18.4539C19 18.24 19 17.96 19 17.3999V11.5999C19 11.0398 19 10.7598 18.891 10.5459C18.7952 10.3577 18.6422 10.2048 18.454 10.1089C18.2401 9.9999 17.9601 9.9999 17.4 9.9999H13L13 18.9999ZM16.2147 6.27066C16.6754 5.11889 15.6211 3.9579 14.469 4.27209C13.8855 4.43124 13.4583 4.93064 13.3915 5.5318L13.1527 7.68089L15.1872 7.17228C15.6492 7.05678 16.0353 6.71916 16.2147 6.27066Z',
                evenodd: true,
            },
        ],
    },
    lightbulb: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M12 0C16.6944 0 20.5 3.80558 20.5 8.5C20.5 11.3249 19.1206 13.8258 17 15.3711V18C17 18.7398 16.5971 19.3835 16 19.7295V20C16 22.2091 14.2091 24 12 24C9.79086 24 8 22.2091 8 20V19.7295C7.4029 19.3835 7 18.7398 7 18V15.3711C4.87935 13.8258 3.5 11.3249 3.5 8.5C3.5 3.80558 7.30558 0 12 0ZM10 20C10 21.1046 10.8954 22 12 22C13.1046 22 14 21.1046 14 20H10ZM9 18H15V16H9V18ZM12 2C8.41015 2 5.5 4.91015 5.5 8.5C5.5 10.8169 6.71329 12.849 8.53809 14H15.4619C17.2867 12.849 18.5 10.8169 18.5 8.5C18.5 4.91015 15.5899 2 12 2Z',
                evenodd: true,
            },
        ],
    },
    browse: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M13 20C13.5523 20 14 20.4477 14 21C14 21.5523 13.5523 22 13 22H3C2.44772 22 2 21.5523 2 21C2 20.4477 2.44772 20 3 20H13ZM19 9C19 6.23858 16.7614 4 14 4C11.2386 4 9 6.23858 9 9C9 11.7614 11.2386 14 14 14C16.7614 14 19 11.7614 19 9ZM8 16C8.55228 16 9 16.4477 9 17C9 17.5523 8.55228 18 8 18H3C2.44772 18 2 17.5523 2 17C2 16.4477 2.44772 16 3 16H8ZM5 12C5.55228 12 6 12.4477 6 13C6 13.5523 5.55228 14 5 14H3C2.44772 14 2 13.5523 2 13C2 12.4477 2.44772 12 3 12H5ZM21 9C21 11.2197 19.9652 13.1961 18.3535 14.4785L21.8643 20.4961C22.1422 20.973 21.9807 21.585 21.5039 21.8633C21.0269 22.1416 20.414 21.9809 20.1357 21.5039L16.627 15.4883C15.8156 15.8171 14.9293 16 14 16C10.134 16 7 12.866 7 9C7 5.13401 10.134 2 14 2C17.866 2 21 5.13401 21 9Z',
                evenodd: false,
            },
        ],
    },
    revert: {
        viewBox: '0 0 16 16',
        paths: [
            {
                d:
                    'M8.29297 2.29295C8.68349 1.90243 9.31651 1.90243 9.70703 2.29295L14.2334 6.81932C14.8854 7.47146 14.8854 8.52851 14.2334 9.18065L9.70703 13.707C9.31651 14.0975 8.68349 14.0975 8.29297 13.707C7.90245 13.3165 7.90244 12.6835 8.29297 12.293L11.5859 8.99999H2C1.44772 8.99999 1 8.55227 1 7.99999C1 7.4477 1.44772 6.99999 2 6.99999H11.5859L8.29297 3.70702C7.90244 3.31649 7.90244 2.68348 8.29297 2.29295Z',
                evenodd: false,
            },
        ],
        rotate: 180,
    },
    'chevrons-right': {
        viewBox: '0 0 16 16',
        paths: [
            {
                d:
                    'M7.45711 4.70711C7.84763 4.31658 7.84763 3.68342 7.45711 3.29289C7.06658 2.90237 6.43342 2.90237 6.04289 3.29289L2.04289 7.29289C1.85536 7.48043 1.75 7.73479 1.75 8C1.75 8.26522 1.85536 8.51957 2.04289 8.70711L6.04289 12.7071C6.43342 13.0976 7.06658 13.0976 7.45711 12.7071C7.84763 12.3166 7.84763 11.6834 7.45711 11.2929L4.16421 8L7.45711 4.70711Z',
                evenodd: false,
            },
            {
                d:
                    'M12.9571 4.70711C13.3476 4.31658 13.3476 3.68342 12.9571 3.29289C12.5666 2.90237 11.9334 2.90237 11.5429 3.29289L7.54289 7.29289C7.35536 7.48043 7.25 7.73478 7.25 8C7.25 8.26522 7.35536 8.51957 7.54289 8.70711L11.5429 12.7071C11.9334 13.0976 12.5666 13.0976 12.9571 12.7071C13.3476 12.3166 13.3476 11.6834 12.9571 11.2929L9.66421 8L12.9571 4.70711Z',
                evenodd: false,
            },
        ],
        rotate: 180,
    },
    stack: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M14.5 7C14.5 9.76142 12.2614 12 9.5 12C6.73858 12 4.5 9.76142 4.5 7C4.5 4.23858 6.73858 2 9.5 2C12.2614 2 14.5 4.23858 14.5 7ZM9.5 10C11.1569 10 12.5 8.65685 12.5 7C12.5 5.34315 11.1569 4 9.5 4C7.84315 4 6.5 5.34315 6.5 7C6.5 8.65685 7.84315 10 9.5 10Z',
                evenodd: true,
            },
            {
                d:
                    'M16 12C18.4853 12 20.5 9.98528 20.5 7.5C20.5 5.01472 18.4853 3 16 3C15.5682 3 15.1507 3.0608 14.7555 3.17431C15.16 3.72911 15.4789 4.35041 15.6925 5.01872C15.8922 5.64337 16 6.3091 16 7C16 8.04425 15.7537 9.03099 15.3161 9.90532C15.0041 10.5287 14.5948 11.095 14.1082 11.5842C14.6833 11.8511 15.3242 12 16 12Z',
                evenodd: false,
            },
            {
                d:
                    'M20.5001 20C21.6047 20 22.5001 19.1046 22.5001 18C22.5001 16.9942 22.0458 15.9808 21.4115 15.2196C20.3048 13.8916 18.414 13 15.5001 13L15.4734 13C17.5614 14.3075 18.8776 16.5509 19.0001 19C19.0001 19.3475 18.9494 19.6831 18.8551 20H20.5001Z',
                evenodd: false,
            },
            {
                d:
                    'M17.5 19C17.5 20.1046 16.6046 21 15.5 21H3.5C2.39543 21 1.5 20.1046 1.5 19C1.5 17.8634 1.97925 16.6943 2.65 15.8C3.85525 14.193 6.01202 13 9.5 13C12.988 13 15.1448 14.193 16.35 15.8C17.0208 16.6943 17.5 17.8634 17.5 19ZM14.75 17C15.5 18 15.5 19 15.5 19H3.5C3.5 19 3.5 18 4.25 17C5 16 6.5 15 9.5 15C12.5 15 14 16 14.75 17Z',
                evenodd: true,
            },
        ],
    },
    sort: {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M8 4C8.2652 4 8.5196 4.1054 8.7071 4.2929L12.7071 8.2929C13.0976 8.6834 13.0976 9.3166 12.7071 9.7071C12.3166 10.0976 11.6834 10.0976 11.2929 9.7071L9 7.4142V19C9 19.5523 8.5523 20 8 20C7.4477 20 7 19.5523 7 19V7.4142L4.7071 9.7071C4.3166 10.0976 3.6834 10.0976 3.2929 9.7071C2.9024 9.3166 2.9024 8.6834 3.2929 8.2929L7.2929 4.2929C7.4804 4.1054 7.7348 4 8 4Z',
                evenodd: true,
            },
            {
                d:
                    'M16 4C16.5523 4 17 4.4477 17 5V16.5858L19.2929 14.2929C19.6834 13.9024 20.3166 13.9024 20.7071 14.2929C21.0976 14.6834 21.0976 15.3166 20.7071 15.7071L16.7071 19.7071C16.3166 20.0976 15.6834 20.0976 15.2929 19.7071L11.2929 15.7071C10.9024 15.3166 10.9024 14.6834 11.2929 14.2929C11.6834 13.9024 12.3166 13.9024 12.7071 14.2929L15 16.5858V5C15 4.4477 15.4477 4 16 4Z',
                evenodd: true,
            },
        ],
    },
    'checkbox-off': {
        viewBox: '1 1 22 22',
        paths: [
            {
                d:
                    'M7 3h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4ZM7 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H7Z',
                evenodd: true,
            },
        ],
    },
    'checkbox-on': {
        viewBox: '1 1 22 22',
        paths: [
            {
                d:
                    'M7 3h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4ZM7.3 12.3 8.7 10.9 10.5 12.7 15.3 7.9 16.7 9.3 10.5 15.5Z',
                evenodd: true,
            },
        ],
    },
    'checkbox-mixed': {
        viewBox: '1 1 22 22',
        paths: [
            {
                d:
                    'M7 3h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4ZM8 11h8v2H8Z',
                evenodd: true,
            },
        ],
    },
    play: {
        viewBox: '0 0 16 16',
        paths: [
            {
                d:
                    'M8.29297 2.29295C8.68349 1.90243 9.31651 1.90243 9.70703 2.29295L14.2334 6.81932C14.8854 7.47146 14.8854 8.52851 14.2334 9.18065L9.70703 13.707C9.31651 14.0975 8.68349 14.0975 8.29297 13.707C7.90245 13.3165 7.90244 12.6835 8.29297 12.293L11.5859 8.99999H2C1.44772 8.99999 1 8.55227 1 7.99999C1 7.4477 1.44772 6.99999 2 6.99999H11.5859L8.29297 3.70702C7.90244 3.31649 7.90244 2.68348 8.29297 2.29295Z',
                evenodd: false,
            },
        ],
    },
    'dd-leave-at-location': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M8 10C9.65679 10 10.9999 11.3432 11 13H12C13.1045 13 13.9999 13.8955 14 15V19C14 21.2091 12.2091 23 10 23H6C3.79086 23 2 21.2091 2 19V15C2.0001 13.8955 2.89549 13 4 13H5C5.0001 11.3432 6.34321 10 8 10ZM4 19C4 20.1046 4.89543 21 6 21H10C11.1046 21 12 20.1046 12 19V15H4V19ZM8 12C7.44778 12 7.0001 12.4478 7 13H9L8.99512 12.8975C8.9437 12.3934 8.51761 12 8 12Z',
                evenodd: true,
            },
            {
                d:
                    'M20 1C21.1045 1 21.9999 1.89551 22 3V21C22 22.1046 21.1046 23 20 23H16.25C15.6977 23 15.25 22.5523 15.25 22C15.2501 21.4478 15.6978 21 16.25 21H20V3H9V7.00098C9 7.55326 8.55228 8.00098 8 8.00098C7.44772 8.00098 7 7.55326 7 7.00098V3C7.0001 1.89551 7.89549 1 9 1H20Z',
                evenodd: false,
            },
            {
                d:
                    'M17.5 10.001C18.3284 10.001 19 10.6725 19 11.501C19 12.3294 18.3284 13.001 17.5 13.001C16.6716 13.001 16 12.3294 16 11.501C16 10.6725 16.6716 10.001 17.5 10.001Z',
                evenodd: false,
            },
        ],
    },
    'dd-meet-at-location': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M20.9879 9.71578C21.7452 8.44994 21.476 6.76193 20.2524 5.81022C19.762 5.42878 19.1865 5.22182 18.6043 5.18444C18.5724 4.61045 18.3723 4.04177 17.9989 3.55676C16.927 2.16452 14.8808 2.01832 13.6218 3.24403L8.63828 8.09599L8.63828 7.37421C8.63828 5.79539 7.3584 4.51551 5.77958 4.51552C4.20074 4.51552 2.92086 5.79544 2.9209 7.37428L2.92096 9.94447C2.92096 9.96309 2.92147 9.9816 2.92248 9.99997C2.92248 12.1864 3.1686 14.1859 3.92871 15.9432C4.6999 17.7262 5.97222 19.196 7.90792 20.3574C10.8379 22.1154 14.5324 21.4873 17.1117 19.3698C18.6803 18.0821 20.78 15.8314 22.0331 14.4445C23.0342 13.3366 23.0397 11.6787 22.0988 10.5496C21.7866 10.1749 21.4042 9.89642 20.9879 9.71578ZM16.4141 4.77686C16.072 4.33246 15.4188 4.28579 15.017 4.67704L9.18466 10.3554C8.23408 11.2809 6.63828 10.6073 6.63828 9.28062L6.63828 7.37421C6.63828 6.89996 6.25383 6.51551 5.77959 6.51552C5.30534 6.51552 4.92089 6.89998 4.9209 7.37423L4.92096 9.94442C4.92096 9.96306 4.92045 9.98158 4.91945 9.99997H4.92231C4.92231 12.0582 5.1583 13.7481 5.76436 15.1493C6.35934 16.5248 7.33707 17.6826 8.93691 18.6425C11.0069 19.8845 13.7858 19.5126 15.8427 17.824C17.2797 16.6443 19.2859 14.5018 20.5491 13.1037C20.8669 12.752 20.8809 12.2122 20.5624 11.83C20.1826 11.3743 19.4935 11.343 19.0741 11.7624L18.1294 12.707L18.127 12.7045L16.8306 14.0009C16.4401 14.3914 15.8069 14.3914 15.4164 14.0009C15.0259 13.6104 15.0259 12.9772 15.4164 12.5867L19.1177 8.88538C19.543 8.46006 19.4993 7.75821 19.0245 7.38892C18.6264 7.0793 18.0601 7.11456 17.7035 7.47117L14.0022 11.1724C13.6117 11.5629 12.9786 11.5629 12.588 11.1724C12.1975 10.7818 12.1975 10.1487 12.588 9.75815L16.3342 6.01198C16.6674 5.67883 16.7016 5.15019 16.4141 4.77686Z',
                evenodd: true,
            },
        ],
    },
    'go-approve': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M14.7256 8.86719C15.0752 8.4399 15.7054 8.3763 16.1328 8.72559C16.5601 9.07518 16.6237 9.70538 16.2744 10.1328L11.7744 15.6328C11.5955 15.8515 11.332 15.985 11.0498 15.999C10.7676 16.0131 10.4927 15.9068 10.293 15.707L7.79297 13.207C7.40244 12.8165 7.40244 12.1835 7.79297 11.793C8.18349 11.4024 8.81651 11.4024 9.20703 11.793L10.9248 13.5107L14.7256 8.86719Z',
                evenodd: false,
            },
            {
                d:
                    'M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z',
                evenodd: true,
            },
        ],
    },
    'go-cancel': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12ZM23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z',
                evenodd: false,
            },
            {
                d:
                    'M16.2071 7.7929C16.5976 8.18342 16.5976 8.81659 16.2071 9.20711L13.4142 12L16.2071 14.7929C16.5976 15.1834 16.5976 15.8166 16.2071 16.2071C15.8166 16.5976 15.1834 16.5976 14.7929 16.2071L12 13.4142L9.20711 16.2071C8.81658 16.5976 8.18342 16.5976 7.7929 16.2071C7.40237 15.8166 7.40237 15.1834 7.7929 14.7929L10.5858 12L7.79289 9.20711C7.40237 8.81658 7.40237 8.18342 7.79289 7.79289C8.18342 7.40237 8.81658 7.40237 9.20711 7.79289L12 10.5858L14.7929 7.7929C15.1834 7.40237 15.8166 7.40237 16.2071 7.7929Z',
                evenodd: true,
            },
        ],
    },
    'go-reorder': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12ZM23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z',
                evenodd: false,
            },
            {
                d:
                    'M11.7071 7.29289C12.0976 7.68342 12.0976 8.31658 11.7071 8.70711L9.41421 11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H9.41421L11.7071 15.2929C12.0976 15.6834 12.0976 16.3166 11.7071 16.7071C11.3166 17.0976 10.6834 17.0976 10.2929 16.7071L6.29289 12.7071C5.90237 12.3166 5.90237 11.6834 6.29289 11.2929L10.2929 7.29289C10.6834 6.90237 11.3166 6.90237 11.7071 7.29289Z',
                evenodd: true,
            },
        ],
    },
    'go-week': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M18 2C20.2091 2 22 3.79086 22 6V18C22 20.2091 20.2091 22 18 22H6C3.79086 22 2 20.2091 2 18V6C2 3.79086 3.79086 2 6 2H18ZM4 6V18C4 19.1046 4.89543 20 6 20H8V4H6C4.89543 4 4 4.89543 4 6ZM10 4V20H14V4H10ZM16 4V20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4H16Z',
                evenodd: true,
            },
        ],
    },
    'select-chevron': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M5.29289 8.79289C5.68342 8.40237 6.31658 8.40237 6.70711 8.79289L12 14.0858L17.2929 8.79289C17.6834 8.40237 18.3166 8.40237 18.7071 8.79289C19.0976 9.18342 19.0976 9.81658 18.7071 10.2071L12.7071 16.2071C12.5196 16.3946 12.2652 16.5 12 16.5C11.7348 16.5 11.4804 16.3946 11.2929 16.2071L5.29289 10.2071C4.90237 9.81658 4.90237 9.18342 5.29289 8.79289Z',
                evenodd: true,
            },
        ],
    },
    'mm-chevron-up': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M11.3692 7.22437C11.762 6.90402 12.341 6.92662 12.7071 7.29273L19.2071 13.7927C19.5976 14.1833 19.5976 14.8163 19.2071 15.2068C18.8166 15.5973 18.1835 15.5973 17.793 15.2068L12 9.41383L6.20708 15.2068C5.81655 15.5973 5.18354 15.5973 4.79302 15.2068C4.40249 14.8163 4.40249 14.1833 4.79302 13.7927L11.293 7.29273L11.3692 7.22437Z',
                evenodd: false,
            },
        ],
    },
    'mm-chevron-down': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M11.3692 7.22437C11.762 6.90402 12.341 6.92662 12.7071 7.29273L19.2071 13.7927C19.5976 14.1833 19.5976 14.8163 19.2071 15.2068C18.8166 15.5973 18.1835 15.5973 17.793 15.2068L12 9.41383L6.20708 15.2068C5.81655 15.5973 5.18354 15.5973 4.79302 15.2068C4.40249 14.8163 4.40249 14.1833 4.79302 13.7927L11.293 7.29273L11.3692 7.22437Z',
                evenodd: false,
            },
        ],
        rotate: 180,
    },
    'mm-share': {
        viewBox: '0 0 16 16',
        paths: [
            {
                d:
                    'M1 12.0027V9.00268C1 8.4504 1.44772 8.00268 2 8.00268C2.55228 8.00268 3 8.4504 3 9.00268V12.0027C3.00001 12.555 3.44772 13.0027 4 13.0027H12C12.5523 13.0027 13 12.555 13 12.0027V9.00268C13 8.4504 13.4477 8.00268 14 8.00268C14.5523 8.00268 15 8.4504 15 9.00268V12.0027C15 13.6595 13.6568 15.0027 12 15.0027H4C2.34315 15.0027 1.00001 13.6595 1 12.0027ZM7 10.0027V3.41674L5.20703 5.20971C4.81652 5.6001 4.18346 5.60014 3.79297 5.20971C3.40248 4.81923 3.40256 4.18618 3.79297 3.79565L6.81934 0.769283L6.94629 0.654049C7.60219 0.119411 8.56937 0.158056 9.18066 0.769283L12.207 3.79565C12.5975 4.18618 12.5975 4.81921 12.207 5.20971C11.8165 5.6001 11.1835 5.60014 10.793 5.20971L9 3.41674V10.0027C8.99991 10.5548 8.55213 11.0026 8 11.0027C7.44777 11.0027 7.00009 10.5549 7 10.0027Z',
                evenodd: false,
            },
        ],
    },
    'dd-info-line': {
        viewBox: '0 0 16 16',
        paths: [
            {
                d:
                    'M8 7C8.55229 6.99999 8.99999 7.44772 9 8V11.5C8.99999 12.0523 8.55227 12.5 8 12.5C7.44776 12.5 7.00001 12.0523 7 11.5V8C6.99999 7.44772 7.44772 7.00001 8 7Z',
                evenodd: false,
            },
            {
                d:
                    'M8 3.5C8.69036 3.5 9.25 4.05964 9.25 4.75C9.25 5.44036 8.69036 6 8 6C7.30964 6 6.75 5.44036 6.75 4.75C6.75 4.05964 7.30964 3.5 8 3.5Z',
                evenodd: false,
            },
            {
                d:
                    'M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58174 16 3.29867e-05 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM8 2C4.68629 2 2 4.68629 2 8C2.00003 11.3137 4.68631 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2Z',
                evenodd: true,
            },
        ],
    },
    'mm-help': {
        viewBox: '0 0 16 16',
        paths: [
            {
                d:
                    'M8 10.499C8.69036 10.499 9.25 11.0587 9.25 11.749C9.25 12.4394 8.69036 12.999 8 12.999C7.30964 12.999 6.75 12.4394 6.75 11.749C6.75 11.0587 7.30964 10.499 8 10.499Z',
                evenodd: false,
            },
            {
                d:
                    'M8.01074 2.99902C9.52386 2.99909 11 4.06494 11 5.875C10.9998 7.44681 9.92865 8.28588 9 8.69434V8.99902C9 9.55126 8.55222 9.99895 8 9.99902C7.44772 9.99902 7 9.55131 7 8.99902V8.49805C7 7.72443 7.51578 7.13792 8.11133 6.90039L8.32715 6.80371C8.52728 6.70264 8.682 6.5886 8.78906 6.46777C8.91389 6.32681 8.99991 6.1506 9 5.875C9 5.37635 8.63813 4.99908 8.01074 4.99902C7.53171 4.99909 7.10617 5.31667 6.96191 5.82324C6.81069 6.35424 6.25759 6.6617 5.72656 6.51074C5.19539 6.3595 4.88685 5.80656 5.03809 5.27539C5.41373 3.95618 6.5903 2.99909 8.01074 2.99902Z',
                evenodd: false,
            },
            {
                d:
                    'M8 0C12.4183 0 16 3.58172 16 8C15.9998 12.4181 12.4181 16 8 16C3.58186 16 0.000230896 12.4181 0 8C0 3.58172 3.58172 0 8 0ZM8 2C4.68629 2 2 4.68629 2 8C2.00023 11.3135 4.68643 14 8 14C11.3136 14 13.9998 11.3135 14 8C14 4.68629 11.3137 2 8 2Z',
                evenodd: true,
            },
        ],
    },
    'mm-gear': {
        viewBox: '0 0 16 16',
        paths: [
            {
                d:
                    'M12.6144 8C12.6144 7.7665 12.5978 7.53754 12.5646 7.31445L12.4806 6.75488L12.9181 6.39551L13.6622 5.78125L12.7589 4.21777L11.3243 4.75586L10.881 4.40234C10.5249 4.11819 10.1261 3.8857 9.6964 3.7168L9.16906 3.50977L8.91808 2H7.11144L6.86046 3.50977L6.33312 3.7168C5.90344 3.88569 5.50464 4.11821 5.14855 4.40234L4.70519 4.75586L3.26964 4.21777L2.3673 5.78125L3.11242 6.39453L3.54894 6.75488L3.46495 7.31445C3.43169 7.53755 3.41515 7.76648 3.41515 8C3.41515 8.23356 3.43265 8.46241 3.46593 8.68555L3.54894 9.24512L3.11242 9.60547L2.3673 10.2178L3.26964 11.7812L4.17394 11.4434L4.70519 11.2441L5.14855 11.5977C5.41557 11.8107 5.70668 11.9947 6.01671 12.1445L6.33312 12.2832L6.86046 12.4902L7.11144 14H8.91808L9.16906 12.4902L9.6964 12.2832C10.1261 12.1143 10.5249 11.8818 10.881 11.5977L11.3243 11.2441L12.7589 11.7812L13.6612 10.2178L12.4806 9.24512L12.5646 8.68555C12.5978 8.46243 12.6144 8.23353 12.6144 8ZM9.01476 8C9.01476 7.44772 8.56704 7 8.01476 7C7.4625 7.00004 7.01476 7.44774 7.01476 8C7.01476 8.55226 7.4625 8.99996 8.01476 9C8.56704 9 9.01476 8.55229 9.01476 8ZM11.0148 8C11.0148 9.65685 9.67161 11 8.01476 11C6.35793 11 5.01476 9.65683 5.01476 8C5.01476 6.34317 6.35793 5.00004 8.01476 5C9.67161 5 11.0148 6.34315 11.0148 8ZM14.6144 8C14.6144 8.13437 14.6096 8.26782 14.6017 8.40039L15.13 8.83594C15.7714 9.36414 15.937 10.2785 15.5216 10.998L14.3644 13.002C13.9489 13.7216 13.0742 14.0356 12.296 13.7441L11.6554 13.5039C11.4328 13.6514 11.2006 13.7851 10.9601 13.9053L10.8487 14.5791C10.7121 15.3988 10.0029 15.9999 9.17199 16H6.85753C6.02661 15.9999 5.31737 15.3987 5.18077 14.5791L5.06847 13.9053C4.8282 13.7852 4.59644 13.6512 4.37413 13.5039L3.73351 13.7441C2.95539 14.0355 2.0806 13.7215 1.66515 13.002L0.507923 10.998C0.0926133 10.2785 0.258345 9.36413 0.899524 8.83594L1.42687 8.40137C1.41888 8.2685 1.41515 8.13467 1.41515 8C1.41515 7.86533 1.41888 7.7315 1.42687 7.59863L0.899524 7.16504C0.257956 6.63686 0.0924222 5.72163 0.507923 5.00195L1.66515 2.99805C2.08059 2.27847 2.95539 1.96456 3.73351 2.25586L4.37316 2.49512C4.59565 2.34768 4.82798 2.21392 5.06847 2.09375L5.18077 1.4209L5.213 1.26953C5.40649 0.528137 6.07853 0.00011526 6.85753 0H9.17199C9.95102 7.4114e-05 10.623 0.528118 10.8165 1.26953L10.8487 1.4209L10.9601 2.09375C11.2006 2.21389 11.4328 2.3477 11.6554 2.49512L12.296 2.25586C13.0741 1.96441 13.9488 2.27849 14.3644 2.99805L15.5216 5.00195C15.9371 5.72165 15.7716 6.63687 15.13 7.16504L14.6017 7.59863C14.6097 7.73152 14.6144 7.8653 14.6144 8Z',
                evenodd: false,
            },
        ],
    },
    'mm-chevron-left': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M13.7929 4.79289C14.1834 4.40237 14.8164 4.40237 15.207 4.79289C15.5975 5.18342 15.5975 5.81643 15.207 6.20696L9.41399 11.9999L15.207 17.7929C15.5975 18.1834 15.5975 18.8164 15.207 19.207C14.8164 19.5975 14.1834 19.5975 13.7929 19.207L7.29289 12.707C6.90237 12.3164 6.90237 11.6834 7.29289 11.2929L13.7929 4.79289Z',
                evenodd: false,
            },
        ],
    },
    'mm-chevron-right': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M8.79286 4.79287C9.18337 4.40236 9.8164 4.4024 10.2069 4.79287L16.7069 11.2929C17.0975 11.6834 17.0975 12.3164 16.7069 12.7069L10.2069 19.2069C9.8164 19.5975 9.18339 19.5975 8.79286 19.2069C8.4024 18.8164 8.40236 18.1834 8.79286 17.7929L14.5858 11.9999L8.79286 6.20693C8.40241 5.81642 8.40241 5.18338 8.79286 4.79287Z',
                evenodd: false,
            },
        ],
    },
    'mm-close': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M18.7929 3.79302C19.1834 3.40249 19.8164 3.40249 20.207 3.79302C20.5974 4.18355 20.5975 4.81658 20.207 5.20708L13.414 12L20.207 18.793C20.5974 19.1835 20.5975 19.8166 20.207 20.2071C19.8165 20.5976 19.1834 20.5975 18.7929 20.2071L11.9999 13.4141L5.20696 20.2071C4.81646 20.5976 4.18342 20.5975 3.79289 20.2071C3.40237 19.8166 3.40237 19.1835 3.79289 18.793L10.5859 12L3.79289 5.20708C3.40237 4.81655 3.40237 4.18354 3.79289 3.79302C4.18342 3.40249 4.81643 3.40249 5.20696 3.79302L11.9999 10.586L18.7929 3.79302Z',
                evenodd: false,
            },
        ],
    },
    'mm-calendar': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M16 1C16.5521 1.00013 16.9998 1.44796 17 2V3H18C20.2089 3.00013 21.9998 4.79111 22 7V19C22 21.2091 20.209 22.9999 18 23H6C3.79086 23 2 21.2091 2 19V7C2.0002 4.79103 3.79098 3 6 3H7V2C7.0002 1.44788 7.44784 1 8 1C8.55205 1.00013 8.9998 1.44796 9 2V3H15V2C15.0002 1.44788 15.4478 1 16 1ZM4 11V19C4 20.1046 4.89543 21 6 21H18C19.1045 20.9999 20 20.1045 20 19V11H4ZM6 5C4.89555 5 4.0002 5.8956 4 7V9H20V7C19.9998 5.89568 19.1043 5.00013 18 5H17V6C17 6.5522 16.5522 6.99987 16 7C15.4477 7 15 6.55228 15 6V5H9V6C9 6.5522 8.55217 6.99987 8 7C7.44772 7 7 6.55228 7 6V5H6Z',
                evenodd: true,
            },
        ],
    },
    'mm-dollar': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z',
                evenodd: true,
            },
            {
                d:
                    'M12.8476 7.36098V6.09998H11.1576V7.34798C9.66255 7.62098 8.75255 8.71298 8.75255 9.93498C8.75255 13.185 13.2376 12.21 13.2376 13.9C13.2376 14.55 12.7176 15.07 11.7426 15.07C10.3776 15.07 9.59755 14.095 9.59755 14.095L8.42755 15.265C8.42755 15.265 9.35055 16.448 11.1576 16.708V17.93H12.8476V16.669C14.4336 16.357 15.3176 15.265 15.3176 13.9C15.3176 10.65 10.8326 11.625 10.8326 9.93498C10.8326 9.41498 11.2876 8.95998 12.0676 8.95998C13.1076 8.95998 13.7576 9.73998 13.7576 9.73998L14.9276 8.50498C14.9276 8.50498 14.2386 7.64698 12.8476 7.36098Z',
                evenodd: false,
            },
        ],
    },
    'mm-clock': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12ZM11 11.5859V7C11 6.44778 11.4478 6.00011 12 6C12.5523 6 13 6.44772 13 7V11.5859L16.207 14.793C16.5976 15.1835 16.5976 15.8165 16.207 16.207C15.8165 16.5974 15.1834 16.5975 14.793 16.207L11.5859 13C11.2109 12.625 11.0001 12.1162 11 11.5859ZM23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z',
                evenodd: false,
            },
        ],
    },
    'mm-cart': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M7 19.5C7.82843 19.5 8.5 20.1716 8.5 21C8.5 21.8284 7.82843 22.5 7 22.5C6.17157 22.5 5.5 21.8284 5.5 21C5.5 20.1716 6.17157 19.5 7 19.5Z',
                evenodd: false,
            },
            {
                d:
                    'M17 19.5C17.8284 19.5 18.5 20.1716 18.5 21C18.5 21.8284 17.8284 22.5 17 22.5C16.1716 22.5 15.5 21.8284 15.5 21C15.5 20.1716 16.1716 19.5 17 19.5Z',
                evenodd: false,
            },
            {
                d:
                    'M3.40234 1.01172C3.75225 1.06556 4.05227 1.30231 4.18262 1.63965L4.70801 3H19.6348L19.7959 3.00977C20.5857 3.10976 21.0985 3.93487 20.7998 4.70312L17.6797 12.7246C17.3808 13.4932 16.641 13.9998 15.8164 14H7.9541L6.2041 16H19C19.5523 16 20 16.4477 20 17C20 17.5523 19.5523 18 19 18H5.87305C4.28378 17.9999 3.43406 16.1278 4.48047 14.9316L6.34863 12.7959L2.56445 3H1C0.447715 3 0 2.55228 0 2C0 1.44772 0.447715 1 1 1H3.25L3.40234 1.01172ZM8.18555 12H15.8164L18.5381 5H5.48047L8.18555 12Z',
                evenodd: true,
            },
        ],
    },
    'mm-cash': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8ZM12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z',
                evenodd: true,
            },
            {
                d:
                    'M20 5C21.6569 5 23 6.34315 23 8V16C23 17.6569 21.6569 19 20 19H4C2.34315 19 1 17.6569 1 16V8C1 6.34315 2.34315 5 4 5H20ZM3 16C3 16.5523 3.44772 17 4 17H4.82617C4.52483 16.1484 3.85162 15.4752 3 15.1738V16ZM21 15.1738C20.1484 15.4752 19.4752 16.1484 19.1738 17H20C20.5523 17 21 16.5523 21 16V15.1738ZM6.89941 7C6.5017 8.95904 4.95904 10.5017 3 10.8994V13.0996C4.95913 13.4973 6.50169 15.0409 6.89941 17H17.1006C17.4983 15.0409 19.0409 13.4973 21 13.0996V10.8994C19.041 10.5017 17.4983 8.95904 17.1006 7H6.89941ZM4 7C3.44772 7 3 7.44772 3 8V8.8252C3.85148 8.5238 4.52487 7.85152 4.82617 7H4ZM19.1738 7C19.4751 7.85152 20.1485 8.5238 21 8.8252V8C21 7.44772 20.5523 7 20 7H19.1738Z',
                evenodd: true,
            },
        ],
    },
    'mm-shield': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M12 3.05014L4 5.71714V11.471C4 15.5952 6.53226 19.2966 10.376 20.7914L12 21.4232L13.624 20.7914C17.4677 19.2966 20 15.5952 20 11.471V5.71714L12 3.05014ZM15.293 8.79038C15.6835 8.39985 16.3165 8.39985 16.707 8.79038C17.0974 9.18092 17.0975 9.81398 16.707 10.2044L11.207 15.7044C10.8166 16.0947 10.1834 16.0947 9.79297 15.7044L7.29297 13.2044C6.90251 12.814 6.90264 12.1809 7.29297 11.7904C7.68349 11.3999 8.31651 11.3999 8.70703 11.7904L10.5 13.5833L15.293 8.79038ZM22 11.471C22 16.42 18.962 20.8618 14.3496 22.6556L12.7246 23.2874C12.2586 23.4686 11.7414 23.4686 11.2754 23.2874L9.65039 22.6556C5.03801 20.8618 2 16.42 2 11.471V5.71714C2 4.85641 2.55072 4.09202 3.36719 3.81967L11.3672 1.15268C11.7777 1.01584 12.2223 1.01584 12.6328 1.15268L20.6328 3.81967C21.4493 4.09202 22 4.85641 22 5.71714V11.471Z',
                evenodd: false,
            },
        ],
    },
    'mm-people': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M8.50049 12C10.5178 12.0001 12.1775 12.4604 13.7319 13.2793C15.2706 14.0901 16.0005 15.7342 16.0005 17.3027V20C16.0004 21.1043 15.1047 21.9997 14.0005 22H3.00049C1.96494 22 1.11363 21.2126 1.01123 20.2041L0.999512 20V17.3018C0.999512 15.7326 1.7309 14.0876 3.271 13.2773C4.82528 12.4597 6.48482 12 8.50049 12ZM8.50049 14C6.82249 14 5.48098 14.3748 4.20166 15.0479C3.46346 15.4364 3.00049 16.2965 3.00049 17.3018V20H14.0005V17.3027C14.0005 16.298 13.5371 15.4378 12.7993 15.0488C11.5202 14.375 10.1793 14.0001 8.50049 14Z',
                evenodd: true,
            },
            {
                d:
                    'M16.9067 13.0342C17.0326 12.4967 17.5703 12.1625 18.1079 12.2881C19.0457 12.5072 19.9074 12.8449 20.7319 13.2793C22.2705 14.09 23.0003 15.7334 23.0005 17.3018V19.999C23.0005 21.1034 22.1048 21.9988 21.0005 21.999H18.8999C18.3476 21.999 17.8999 21.5513 17.8999 20.999C17.9003 20.4471 18.3479 19.999 18.8999 19.999H21.0005V17.3018C21.0003 16.2971 20.5371 15.4376 19.7993 15.0488C19.1084 14.6849 18.4066 14.4115 17.6528 14.2354C17.1151 14.1097 16.7811 13.572 16.9067 13.0342Z',
                evenodd: false,
            },
            {
                d:
                    'M8.50049 2C10.9856 2.00026 13.0005 4.01488 13.0005 6.5C13.0004 8.98504 10.9855 10.9997 8.50049 11C6.01529 11 4.00062 8.9852 4.00049 6.5C4.00049 4.01472 6.0152 2 8.50049 2ZM8.50049 4C7.11977 4 6.00049 5.11929 6.00049 6.5C6.00062 7.88062 7.11985 9 8.50049 9C9.88092 8.99974 11.0004 7.88047 11.0005 6.5C11.0005 5.11944 9.881 4.00026 8.50049 4Z',
                evenodd: true,
            },
            {
                d:
                    'M15.4995 2C17.9848 2 19.9995 4.01472 19.9995 6.5C19.9994 8.9852 17.9847 11 15.4995 11C15.3423 11 15.1864 10.9915 15.0327 10.9756C14.4836 10.9186 14.0835 10.4271 14.1401 9.87793C14.1971 9.32897 14.6888 8.92987 15.2378 8.98633C15.3233 8.99518 15.411 8.99998 15.4995 9C16.8802 9 17.9994 7.88063 17.9995 6.5C17.9995 5.11928 16.8802 4 15.4995 4C15.411 4.00002 15.3233 4.00482 15.2378 4.01367C14.6889 4.0701 14.1972 3.67091 14.1401 3.12207C14.0833 2.57281 14.4835 2.08139 15.0327 2.02441C15.1864 2.00852 15.3423 2.00002 15.4995 2Z',
                evenodd: false,
            },
        ],
    },
    'mm-bell': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M12 1C12.5522 1 12.9999 1.44783 13 2V3.07227C16.3921 3.55755 18.9999 6.47369 19 10V17H20C20.5522 17 20.9999 17.4478 21 18C21 18.5523 20.5523 19 20 19H16C15.9998 21.209 14.209 23 12 23C9.79098 23 8.0002 21.209 8 19H4C3.44772 19 3 18.5523 3 18C3.00013 17.4478 3.4478 17 4 17H5V10C5.00012 6.47369 7.60786 3.55755 11 3.07227V2C11.0001 1.44783 11.4478 1 12 1ZM10 19C10.0002 20.1044 10.8956 21 12 21C13.1044 21 13.9998 20.1044 14 19H10ZM12 5C9.23866 5 7.00013 7.23869 7 10V17H17V10C16.9999 7.23869 14.7613 5 12 5Z',
                evenodd: true,
            },
        ],
    },
    'mm-external': {
        viewBox: '0 0 16 16',
        paths: [
            {
                d:
                    'M6 1C6.55228 1 7 1.44772 7 2C7 2.55228 6.55228 3 6 3H4C3.44772 3 3 3.44772 3 4V12C3 12.5523 3.44772 13 4 13H12C12.5523 13 13 12.5523 13 12V10C13 9.44772 13.4477 9 14 9C14.5523 9 15 9.44772 15 10V12C15 13.6569 13.6569 15 12 15H4C2.34315 15 1 13.6569 1 12V4C1 2.34315 2.34315 1 4 1H6Z',
                evenodd: false,
            },
            {
                d:
                    'M13.333 1C14.2535 1 15 1.74652 15 2.66699V6C15 6.55228 14.5523 7 14 7C13.4477 7 13 6.55228 13 6V4.41406L8.20703 9.20703C7.81654 9.59726 7.18343 9.59731 6.79297 9.20703C6.40271 8.81657 6.40275 8.18345 6.79297 7.79297L11.5859 3H10C9.44771 3 9 2.55228 9 2C9 1.44772 9.44771 1 10 1H13.333Z',
                evenodd: false,
            },
        ],
    },
    'mm-key': {
        viewBox: '0 0 24 24',
        paths: [
            {
                d:
                    'M7.5 6C8.32843 6 9 6.67157 9 7.5C9 8.32843 8.32843 9 7.5 9C6.67157 9 6 8.32843 6 7.5C6 6.67157 6.67157 6 7.5 6Z',
                evenodd: false,
            },
            {
                d:
                    'M9 1C13.4183 1 17 4.58172 17 9C17 9.92291 16.8404 10.8099 16.5518 11.6367L22.707 17.793C22.8946 17.9805 23 18.2348 23 18.5V22C23 22.5523 22.5523 23 22 23H18.5C18.2348 23 17.9805 22.8946 17.793 22.707L15.0859 20H12C11.4477 20 11 19.5523 11 19V16.7441C10.3599 16.909 9.69018 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1ZM9 3C5.68629 3 3 5.68629 3 9C3 12.3137 5.68629 15 9 15C9.92205 15 10.7933 14.7924 11.5713 14.4229L12.0898 14.1758L13 15.0859V18H15.9141L18.9141 21H21V18.9141L14.1855 12.0996L14.4697 11.4697C14.8097 10.7179 15 9.88225 15 9C15 5.68629 12.3137 3 9 3Z',
                evenodd: true,
            },
        ],
    },
}

export const DD_ICON_ALIASES = {
    access_time: 'clock',
    account_circle: 'person',
    add: 'plus',
    add_circle: 'plus-circle',
    add_circle_outline: 'plus-circle',
    arrow_back: 'arrow-left',
    arrow_downward: 'arrow-down',
    arrow_drop_down: 'select-chevron',
    arrow_drop_up: 'chevron-up',
    arrow_forward: 'arrow-right',
    arrow_upward: 'arrow-up',
    article: 'document',
    assignment: 'clipboard-list',
    attach_file: 'upload',
    autorenew: 'revert',
    block: 'minus-circle',
    cached: 'revert',
    call: 'phone',
    call_split: 'swap',
    cancel: 'circle-x',
    chat: 'message',
    check: 'check',
    check_box: 'checkbox-on',
    check_box_outline_blank: 'checkbox-off',
    check_circle: 'check-circle',
    chevron_left: 'chevron-left',
    chevron_right: 'chevron-right',
    circle: 'dot',
    clear: 'mm-close',
    close: 'mm-close',
    cloud_download: 'download',
    cloud_upload: 'upload',
    content_copy: 'copy',
    create: 'pencil',
    create_new_folder: 'document',
    credit_card: 'credit-card',
    date_range: 'calendar',
    'dd-info-line': 'dd-info-line',
    'dd-leave-at-location': 'dd-leave-at-location',
    'dd-meet-at-location': 'dd-meet-at-location',
    delete: 'trash',
    delete_forever: 'trash',
    delete_outline: 'trash',
    description: 'document',
    directions_bike: 'bike',
    do_not_disturb: 'minus-circle',
    done: 'check',
    double_arrow: 'chevrons-right',
    download: 'download',
    drag_indicator: 'more-vertical',
    edit: 'pencil',
    email: 'email',
    error: 'alert-circle',
    error_outline: 'alert-circle',
    event: 'calendar',
    expand_less: 'chevron-up',
    expand_more: 'chevron-down',
    fiber_manual_record: 'dot',
    file_copy: 'copy',
    file_download: 'download',
    file_upload: 'upload',
    filter_alt: 'browse',
    filter_list: 'browse',
    folder: 'document',
    format_list_bulleted: 'list',
    format_list_numbered: 'list',
    format_quote: 'message',
    get_app: 'download',
    'go-approve': 'go-approve',
    'go-cancel': 'go-cancel',
    'go-reorder': 'go-reorder',
    'go-week': 'go-week',
    grading: 'clipboard',
    group: 'mm-people',
    groups: 'mm-people',
    help: 'help',
    help_outline: 'help',
    highlight_off: 'circle-x',
    home: 'home',
    indeterminate_check_box: 'checkbox-mixed',
    info: 'info',
    info_outline: 'info',
    keyboard_arrow_down: 'chevron-down',
    keyboard_arrow_left: 'chevron-left',
    keyboard_arrow_right: 'chevron-right',
    keyboard_arrow_up: 'chevron-up',
    launch: 'external-link',
    layers: 'stack',
    lightbulb: 'lightbulb',
    list: 'list',
    list_alt: 'clipboard-list',
    local_atm: 'banknote',
    local_offer: 'tag',
    location_on: 'location-pin',
    lock: 'lock',
    mail: 'email',
    map: 'map-pin',
    menu: 'menu',
    message: 'message',
    'mm-bell': 'mm-bell',
    'mm-calendar': 'mm-calendar',
    'mm-cart': 'mm-cart',
    'mm-cash': 'mm-cash',
    'mm-chevron-down': 'mm-chevron-down',
    'mm-chevron-left': 'mm-chevron-left',
    'mm-chevron-right': 'mm-chevron-right',
    'mm-chevron-up': 'mm-chevron-up',
    'mm-clock': 'mm-clock',
    'mm-close': 'mm-close',
    'mm-dollar': 'mm-dollar',
    'mm-external': 'mm-external',
    'mm-gear': 'mm-gear',
    'mm-help': 'mm-help',
    'mm-key': 'mm-key',
    'mm-people': 'mm-people',
    'mm-share': 'mm-share',
    'mm-shield': 'mm-shield',
    mode_edit: 'pencil',
    more_horiz: 'more-horizontal',
    more_time: 'clock',
    more_vert: 'more-vertical',
    motorcycle: 'bike',
    navigate_before: 'chevron-left',
    navigate_next: 'chevron-right',
    notifications: 'mm-bell',
    notifications_active: 'mm-bell',
    notifications_none: 'mm-bell',
    open_in_new: 'external-link',
    outgoing_mail: 'send',
    payments: 'banknote',
    pedal_bike: 'bike',
    people: 'mm-people',
    person: 'person',
    phone: 'phone',
    picture_as_pdf: 'document',
    place: 'location-pin',
    play_arrow: 'play',
    print: 'print',
    priority_high: 'alert-circle',
    publish: 'upload',
    query_builder: 'clock',
    receipt: 'receipt',
    redeem: 'gift',
    remove: 'minus',
    replay: 'revert',
    replay_circle_filled: 'revert',
    report_problem: 'warning',
    restaurant: 'fork-spoon',
    restaurant_menu: 'fork-spoon',
    room: 'location-pin',
    rotate_left: 'revert',
    schedule: 'clock',
    search: 'search',
    send: 'send',
    settings: 'gear',
    settings_backup_restore: 'revert',
    sort: 'sort',
    star: 'star',
    store: 'store',
    storefront: 'store',
    swap_horiz: 'swap',
    today: 'calendar',
    tune: 'browse',
    two_wheeler: 'bike',
    undo: 'revert',
    upload_file: 'upload',
    visibility: 'eye',
    visibility_off: 'eye-closed',
    warning: 'warning',
}
